<template>
  <div class="login-body promote">
    <van-popup
      v-model="$store.state.isDeposit"
      z-index="9999"
      position="bottom"
    >
      <div class="Recharge-box">
        <van-nav-bar
          :title="$t('Login._Depósito')"
          left-arrow
          placeholder
          @click-left.stop="onClickLeft"
        >
          <div slot="right">
            <div class="So_waOZgg7qEl0wURIQz" @click="doJump('suporte')">
              <div class="blXLPejbalUrq5IycYVR">
                <svg-icon
                  className="imageWrap"
                  icon-class="style_2_icon_btm_kf--svgSprite:all"
                />
              </div>
            </div>
          </div>
          <div slot="right">
            <div class="So_waOZgg7qEl0wURIQz" @click.stop="isRecordDetails = !isRecordDetails">
              <div class="blXLPejbalUrq5IycYVR">
                <svg-icon
                  className="imageWrap"
                  icon-class="img_cjc_jl--svgSprite:all"
                />
              </div>
            </div>
          </div>
        </van-nav-bar>
        <div class="_recharge-header_1s451_30">
          <span class="_title_1s451_36">{{$t('Recharge._PaymentMethod')}}</span>
          <div class="glbY5bkp9x7KTYOGrdBC">
            <i
              data-id="sprite_main_flag_1x1_Brazil"
              aria-hidden="true"
              focusable="false"
              class=""
              :style="`display: inline-block; position: relative; width: 0.34rem; height: 0.34rem; background-image: url(${_coloImg}); background-position: ${conutryPosion}; background-size: 8.81571rem 8.60321rem;`"
            ></i>
            <div
              class="vy918omw_N7rBkJ235XX IMl873FTgqqNlSitFJrT iyrfQ72Vih_uHUFOsiR4 currencyInfoBox main VOgj9FBCnkozjr2NA7rl"
              style="--row-align: center; --mode: flex; --column-align: center"
            >
              <section
                class="iw9FDOIygJyoQtUHSJAg currency-count"
                style="font-size: 0.18rem"
              >
                <div class="countTextBox">
                  <span
                    class="SSAbrhtT3U690CrzLUd5 SSYrjrFkdeGEfKeXOPu3 count-to"
                  >
                    <span class="notranslate">{{ userBalance }}</span>
                  </span>
                  <div
                    class="refresh-icon"
                    :class="{ animate__manimated: animate__manimated }"
                    @click="animate_conter"
                  >
                    <svg-icon
                      className="refresh-icon"
                      style="cursor: pointer"
                      icon-class="style_1_icon_sx--svgSprite:all"
                    />
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
        <div style="padding: 0px 0.2rem;">
          <div class="conter_tops">
            <div class="conter_tops-cone">
              <svg-icon
                className="imageWrap"
                style="color: var(--theme-filter-active-color)"
                icon-class="icon_cz_zxcz1--svgSprite:all"
              />
              <span class="JW9l1M000tsWqSNVub_5">{{
                $t('Login._Depósitoonline')
              }}</span>
            </div>
          </div>
        </div>
        <div class="scroll-container">
          <div class="e8siic_ICXmLcAr12pgU">
            <div
              v-if="zhifupaytype.status == 'show'"
              style="border-bottom: thin solid var(--theme-color-line)"
            >
              <ul class="qlHv4PpCNi4nGFQLaRq0">
                <li
                  data-id="600084"
                  class="tivA24cSEjfykc3h2PmN"
                  style="width: 48%"
                >
                  <dl class="_vmaNbC7tMMJ99x929N7">
                    <dt v-if="zhifupaytype.icon != '#'">
                      <img class="contee" :src="zhifupaytype.icon" alt="" />
                    </dt>
                    <dd>{{ zhifupaytype.name }}</dd>
                    <div
                      v-if="$store.state.config.recharge_give > 0 && have_bonus"
                      class="uh6csli2MHzFz87__Phx tool-tips r1QnBDk2QnzYN6t7hweu"
                      style="
                        --cu-top: -0.15rem;
                        --cu-right: -0.1rem;
                        --cu-left: unset;
                      "
                    >
                      <p class="tool-tips-box sNgyWmhVEZVrbSGKDBra">
                        +&nbsp;{{ $store.state.config.recharge_give }}%
                      </p>
                      <p class="tool-tips-tail YiNQnpSJUes7u5sqBZhp"></p>
                    </div>
                  </dl>
                  <div
                    class="_ojhUxKWGyFdJIV2Lodx subscript"
                    style="display: flex"
                  >
                    <svg-icon
                      className="imageWrap"
                      style="
                        width: 100%;
                        height: 100%;
                        color: var(--theme-filter-active-color);
                      "
                      icon-class="comm_img_corner--svgSprite:all"
                    />
                    <svg-icon
                      className="duihap"
                      style="color: var(--theme-web_filter_gou)"
                      icon-class="comm_icon_gou--svgSprite:all"
                    />
                  </div>
                </li>
              </ul>
            </div>
          
            <!-- 支付通道 -->
            <ul
                class="qlHv4PpCNi4nGFQLaRq0"
                style="overflow: hidden; margin-top: 0.2rem"
              >
                <li
                  data-id="600084"
                  :class="{
                    tivA24cSEjfykc3h2PmN: paymentsActive == index
                  }"
                  v-if="index <= 5 || showAllChannel"
                  @click="onMfeCon(index, 'top')"
                  v-for="(item, index) in zhifupayments"
                  :key="index"
                >
                  <dl class="_vmaNbC7tMMJ99x929N7">
                    <dt v-if="item.icon != '#'">
                      <img class="contee" :src="item.icon" alt="" />
                    </dt>
                    <dd>{{ item.name }}</dd>
                  </dl>
                  <div
                    v-if="paymentsActive == index"
                    class="_ojhUxKWGyFdJIV2Lodx subscript"
                    style="display: flex"
                  >
                    <svg-icon
                      className="imageWrap"
                      style="
                        width: 100%;
                        height: 100%;
                        color: var(--theme-filter-active-color);
                      "
                      icon-class="comm_img_corner--svgSprite:all"
                    />
                    <svg-icon
                      className="duihap"
                      style="color: var(--theme-web_filter_gou)"
                      icon-class="comm_icon_gou--svgSprite:all"
                    />
                  </div>
                </li>
              </ul>
              <div
                v-if="zhifupayments.length > 6"
                class="BKfC6Trv2S3lop0AQYI1"
                @click="isShmeoteng('channel')"
              >
                <p>
                  <span>{{
                    showAllChannel ? $t('Login._Fechar') : $t('Login._Expandir')
                  }}</span>
                  <span
                    :style="showAllChannel ? 'transform:rotate(-45deg)' : ''"
                    class="NvAx2rtSlQ6tCymRPyMO"
                  ></span>
                </p>
              </div>

            <div class="bIfFIphSiWAweeD39Bmu">{{ $t('Login._Depósito') }}</div>

            <ul class="ceiktj0nGFZYA3JZ65zu">
              <li
                :class="{ ceiktj0nGFZYA3JZ65zuchose: chooseMoney == index }"
                v-for="(item, index) in zhifupayments[paymentsActive].config"
                @click="onMfeCon(index, 'bottom', item)"
              >
                <div class="_vmaNbC7tMMJ99x929N9">
                  <div
                    style="
                      border-radius: .1rem;
                      background-color: var(--theme-bg-color);
                      font-size: 0.26rem;
                      line-height: 0.4rem;
                      width: 100%;
                      font-weight: 700;
                      height: 100%;
                      display: flex;
                      justify-content: center;
                      align-items: center;
                      flex-direction:column
                    "
                  >
                    <span>{{ formatCurrency(item[0],'',0) }}</span>
                    <div v-if="item[1] && have_bonus" class="_reward-box_k0yoz_88">
                      <span class="_reward_k0yoz_88">+{{ formatCurrency(item[1],'',0) }}</span>
                    </div>
                  </div>
                </div>
              </li>
            </ul>

            <div class="foen-yes" style="margin-bottom: 0.2rem">
              <van-search
                left-icon="a"
                type="number"
                v-model="amount"
                @focus="isFun('isFocusAmount', true)"
                :clearable="false"
                @blur="handleAmountBlur"
                @clear="clearConst"
                @cancel="clearConst"
                clearable
                :placeholder="minMaxRecharge()"
                :class="{
                  'input-active': isFocusAmount,
                  _sdfisndifnsdf: giftMoney && have_bonus
                }"
              >
                <div slot="left" style="display: flex; align-items: center">
                  <span
                    style="
                      font-size: 0.3rem;
                      color: var(--theme-text-color-darken);
                    "
                    class="ZEcfoKF3Q_zq5EqaOdUy"
                    >{{ $store.state.config.currency }}</span
                  >
                </div>
              </van-search>
              <div v-if="giftMoney && have_bonus" class="_give_1idld_30">
                <div class="_inner-content_1idld_48">
                  {{ $t('components._recebera') }}
                  <span class="_income_1idld_56">{{ giftMoney.total_money }}</span>
                  <span class="_receive-tips_1idld_48">{{
                    $t('components._coletar')
                  }}</span>
                  {{ $t('components._evento') }}
                  <span class="_gift_1idld_51">+{{ giftMoney.gift_money }}</span>
                </div>
              </div>
            </div>
              <div v-if="$store.state.config.show_with_bonus" class="flex items-center" style="padding-bottom:0.2rem;font-size: 0.28rem;font-weight: 600;color: var(--theme-text-color-darken)">
                <van-checkbox v-model="have_bonus" checked-color="var(--theme-primary-color)" icon-size="0.4rem" shape="square"></van-checkbox>
                <span style="margin-left: 0.2rem;">{{ $t('Recharge._withBonus') }}</span>
              </div>
            <div v-if="showTimer && have_bonus" class="_normal-style-container_1aor4_38">
              <div class="_title_1aor4_30">
                <div class="_title-img_17u6z_30 _normal_17u6z_88">
                  <span class="_title-img-right_17u6z_43"
                    ><span class="_title-img-right-cnt_17u6z_61"
                      ><img
                        class="lobby-image lobby-image _title-img-icon_17u6z_55"
                        data-load-strategy="loading-set@1:lazy@1"
                        data-status="success"
                        data-thumb="0"
                        data-id="3cc044ba-4dc7-4266-9e04-a9e888b75795"
                        src="https://o777aniloc.colina777.app/siteadmin/skin/lobby_asset/common/common/deposit/img_czjl_mccz.avif?manualVersion=1&amp;version=v6.4.47"
                        alt="."
                      /><span class="_title-img-right-text_17u6z_67">{{ $t('components._Deppsito') }}</span></span
                    ></span
                  >
                </div>
                <div>
                  <div class="_limited-time_43juf_30">
                    <div>
                      <img
                        class="lobby-image lobby-image _time-img_43juf_41"
                        data-load-strategy="loading-set@1:lazy@0"
                        data-status="success"
                        data-thumb="0"
                        data-id="aa365a02-f39e-4111-83a7-fdbf03251c1b"
                        src="https://o777aniloc.colina777.app/siteadmin/skin/lobby_asset/common/common/deposit/img_czjl_xs.avif?manualVersion=1&amp;version=v6.4.47"
                        alt="."
                      />
                      <span class="_text_43juf_60">LT</span>
                      <div class="_rectangle_43juf_44">
                        <div class="_triangle_43juf_51"></div>
                      </div>
                      <span class="_count-time_43juf_66"
                        ><span>{{ countdownTime }}</span></span
                      >
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <div class="_above_1aor4_55">----- <span>{{ $t('components._Participacao') }}</span> -----</div>
                <!-- todo 需要替换list -->
                <div class="_option-item-cnt_1aor4_71 _normal_1aor4_38"
                v-for="(item, index) in filteredPaymentConfig"
                :key="index"
                >
                  <div v-if="!showAllGift || (item[1] && item[1] > 0)" class="_option-item_1aor4_52 _normal_1aor4_38">
                    <div class="_left_1aor4_123">
                      <div class="_border-left_1aor4_123">
                        
                      </div>
                      <img class="lobby-image lobby-image _img-je_1aor4_119" data-load-strategy="loading-set@1:lazy@0" data-status="success" data-thumb="0" data-id="53fef810-2336-43c7-bcd5-6369c6b0d3c6" src="https://o777aniloc.colina777.app/siteadmin/skin/lobby_asset/common/common/deposit/img_czjl_je2.avif?manualVersion=1&amp;version=v6.4.47" alt="."></img>
                      <div><span class="_give_1aor4_170">{{ $t('_VIP._Bônus') }}</span><span class="_currency_1aor4_183">{{ formatCurrency(item[1]) }}</span></div>
                    </div>
                    <div class="_right_1aor4_162">
                      <div>
                        <div class="_condition_1aor4_277">
                          <div class="_text_1aor4_280">
                            {{ $t('Recharge._Firstdeposit') }}
                            <span class="_amount_1aor4_300">≥</span>
                            <span class="_amount_1aor4_300">{{ formatCurrency(item[0]) }}</span>
                          </div></div>
                        </div>
                        <div class="_blank_1aor4_179"></div>
                      </div>

                      <i v-if="chooseGift == index" class="lobby-image lobby-image _icon-gou_1aor4_174" data-load-strategy="loading-set@0:lazy@0" data-status="success" data-thumb="0" data-id="f1bd4699-f741-4eff-8f7a-9e095b18d655" data-src="/siteadmin/skin/lobby_asset/common/web/common/comm_icon_gou.svg" style="display: inline-flex; justify-content: center; align-items: center; color:var(--theme-secondary-color-success)">
                        <svg width="1em" height="1em" fill="currentColor" class="" viewBox="0 0 20 15">
                          <path id="4469ced758951ca2b6aaeda354ba8a78-comm_icon_gou" d="M1234.22-597.615l-6.584-5.628a1.524,1.524,0,0,1-.149-2.141,1.5,1.5,0,0,1,2.128-.15l5.438,4.648,9.417-10.834a1.5,1.5,0,0,1,2.128-.15,1.525,1.525,0,0,1,.149,2.141l-10.4,11.964a1.5,1.5,0,0,1-1.139.522A1.494,1.494,0,0,1,1234.22-597.615Z" transform="translate(-1227.117 612.242)"></path>
                        </svg>
                      </i>
                      <div v-else style="width: 19px;margin-left: .3rem;"></div>
                  </div>
                </div>
              </div>
            </div>
            <div
              v-if="showTimer && have_bonus && giftList.length > 3"
              class="BKfC6Trv2S3lop0AQYI1"
              style="border-bottom: none;"
              @click="isShmeoteng('gift')"
            >
              <p>
                <span>{{
                  showAllGift ? $t('Login._Fechar') : $t('Login._Expandir')
                }}</span>
                <span
                  :style="showAllGift ? 'transform:rotate(-45deg)' : ''"
                  class="NvAx2rtSlQ6tCymRPyMO"
                ></span>
              </p>
            </div>
            <!--  -->
            <div v-if="showCpfNo || showCpfName" class="JqPcJmLp1BV_0pDIq65q">
              <p>
                {{ $t('components._Preencha') }}<br />{{
                  $t('components._normalmente')
                }}
              </p>
            </div>
            <div
              v-if="showCpfName"
              class="foen-yes"
              style="margin-bottom: 0.2rem"
            >
              <van-search
                left-icon="a"
                type="text"
                v-model="cpf_name"
                @focus="isFun('isFocusCpfName', true)"
                :clearable="false"
                @blur="isFun('isFocusCpfName', false)"
                @clear="clearConst"
                @cancel="clearConst"
                clearable
                :placeholder="$t('components._Introduzaoseunomereal')"
                :class="{
                  'input-active': isFocusCpfName
                }"
              >
                <div
                  slot="left"
                  style="
                    color: var(--theme-text-color-darken);
                    font-size: 0.18rem;
                    display: flex;
                    align-items: center;
                  "
                >
                  <svg-icon
                    className="prefix"
                    icon-class="input_icon_zsxm--svgSprite:all"
                  />
                </div>
              </van-search>
            </div>
            <div
              v-if="showCpfNo"
              class="foen-yes"
              style="margin-bottom: 0.2rem"
            >
              <van-search
                left-icon="a"
                type="number"
                maxlength="11"
                v-model="cpf_no"
                @focus="isFun('isFocusCpfNo', true)"
                :clearable="false"
                @blur="isFun('isFocusCpfNo', false)"
                @clear="clearConst"
                @cancel="clearConst"
                clearable
                :placeholder="$t('components._IntroduzadoCPF')"
                :class="{
                  'input-active': isFocusCpfNo
                }"
              >
                <div
                  slot="left"
                  style="
                    color: var(--theme-text-color-darken);
                    font-size: 0.18rem;
                    display: flex;
                    align-items: center;
                  "
                >
                  <svg-icon
                    className="prefix"
                    icon-class="input_icon_cpf--svgSprite:all"
                  />
                </div>
              </van-search>
            </div>
            <div v-if="!showTimer" class="JqPcJmLp1BV_0pDIq65q">
              <p>{{ $t('Login._Lembrete') }}</p>
            </div>
            <div
              style="
                display: flex;
                justify-content: center;
                margin-bottom: 0.1rem;
                margin-top: 0.4rem;
              "
            >
              <button
                type="button"
                @click="recharge"
                style="width: 97%; border-radius: 0.14rem"
                class="GaL3XJonIwzK4ZeJyCyq"
              >
                {{ $t('Login._RecarregueAgora') }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </van-popup>
    <RechargeDetails
      v-if="isRecordDetails"
      @isRecordFun="isRecordDetails = false"
      :isRecord="isRecordDetails"
    ></RechargeDetails>
  </div>
</template>

<script>
// payments
import RechargeDetails from '@/components/Recharge/Details.vue';
import { payments, recharge } from '@/apis/modules/login.js';
import { Toast } from 'vant';
export default {
  components: {
    RechargeDetails
  },
  props: {
    isRecord: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    moneyInfo() {
      return this.$store.state.moneyInfo;
    },
    giftList() {
      if(this.zhifupayments && this.zhifupayments[this.paymentsActive] && this.zhifupayments[this.paymentsActive].config) {
        return this.zhifupayments[this.paymentsActive].config.filter(item => {
          return item[1] > 0
        })
      }
      return []
    },
    giftMoney() {

      if(this.chooseMoney < 0 || !this.zhifupayments) {
        return undefined
      } 
      const config = this.zhifupayments[this.paymentsActive].config
      const money = config[this.chooseMoney][0] ? parseInt(config[this.chooseMoney][0]) : 0
      const gift_money = config[this.chooseMoney][1] ? parseInt(config[this.chooseMoney][1]) : 0
      if (gift_money > 0) {
        const payMoney = parseFloat(this.amount)
        return {
          money: money,
          gift_money: this.formatCurrency(gift_money),
          total_money: this.formatCurrency(payMoney + gift_money)
        }
      } else {
        return undefined
      }
    },
    filteredPaymentConfig() {
      // 获取当前支付方式的配置
      let config = this.zhifupayments && this.zhifupayments[this.paymentsActive] && this.zhifupayments[this.paymentsActive].config || [];
      if (this.showAllGift) {
        // 当 showAllGift = true 时，显示全部
        this.chooseGift = this.chooseMoney;
        return config;
      } else {
        // 当 showAllGift = false 时，只显示指定条目
        let choose = (this.chooseMoney >= 0 && config[this.chooseMoney][1] > 0) ? config[this.chooseMoney] : undefined;
      
        // 过滤出指定索引的项目
        let tempConfig = config.filter((item, index) => index != this.chooseMoney && item[1] > 0);
        let newList = tempConfig.filter((item, index) => index < (choose ? 2 : 3));
        this.chooseGift = this.chooseMoney >= 0 && choose ? 0 : -1;
        return choose ? [choose,...newList] : newList;
      }
    }
  },

  watch: {
    moneyInfo: {
      handler(val) {
        this.showBalance();
      },
      deep: true
    }
  },
  data() {
    return {
      have_bonus:true,
      isFocusAmount: false,
      isFocusCpfName: false,
      isFocusCpfNo: false,
      showAllChannel: false,
      showAllGift: false,
      isRecordDetails: false,
      countdownTime: '00:00:00.0',
      countdownTimer: null,
      activeName: '',
      activeLength: 12,
      paymentsActive: 0,
      chooseMoney: -1,
      chooseGift: -1,
      showCpfName: false,
      showCpfNo: false,
      amount: '',
      cpf_name: this.$store.state.rechargeCpf.name,
      cpf_no: this.$store.state.rechargeCpf.cpf,
      zhifupaytype: [],
      zhifupayments: [],
      showTimer: false,
      index: 0,
      conutryPosion: '-8.11143rem -3.16929rem',
      userBalance: '0,00',
      animate__manimated: false,
      giftInfo: { money: 100 }
    };
  },
  created() {
    this.payments();
    if (this.$store.state.config.currency == 'R$') {
      this.conutryPosion = '-8.11143rem -3.16929rem';
    } else if (this.$store.state.config.currency == '$') {
      this.conutryPosion = '-7.25143rem -7.47929rem';
    } else if (this.$store.state.config.currency == '₹') {
      this.conutryPosion = '-8.11143rem -1.04029rem';
    } else if (this.$store.state.config.currency == '¢') {
      this.conutryPosion = '-2.14143rem -8.24029rem';
    }
    this.showBalance();
  },
  mounted() {
    // 启动倒计时
    this.startCountdown();
  },
  beforeDestroy() {
    // 清理倒计时
    this.clearCountdown();
  },
  methods: {
    // 启动倒计时
    startCountdown() {
      this.updateCountdown();
      this.countdownTimer = setInterval(() => {
        this.updateCountdown();
      }, 100); // 每0.1秒更新一次
    },
    
    // 更新倒计时
    updateCountdown() {
      const now = new Date();
      const todayStart = new Date(now.getFullYear(), now.getMonth(), now.getDate());
      const elapsedMs = now.getTime() - todayStart.getTime();
      const remainingMs = 24 * 60 * 60 * 1000 - elapsedMs;
      
      if (remainingMs <= 0) {
        this.countdownTime = '00:00:00.0';
        return;
      }
      
      const hours = Math.floor(remainingMs / (60 * 60 * 1000));
      const minutes = Math.floor((remainingMs % (60 * 60 * 1000)) / (60 * 1000));
      const seconds = Math.floor((remainingMs % (60 * 1000)) / 1000);
      const deciseconds = Math.floor((remainingMs % 1000) / 100);
      
      this.countdownTime = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}.${deciseconds}`;
    },
    
    // 清理倒计时
    clearCountdown() {
      if (this.countdownTimer) {
        clearInterval(this.countdownTimer);
        this.countdownTimer = null;
      }
    },

    animate_conter(e) {
      this.animate__manimated = true;
      this.getBalance();
      let time = setTimeout(() => {
        clearTimeout(time);
        this.animate__manimated = false;
      }, 300);
    },
    showBalance() {
      this.userBalance = this.$store.state.config.balance_no_bonus.includes(
        'user_center'
      )
        ? this.moneyInfo.balance_coin_str
        : this.moneyInfo.balance_total_str;
    },
    minMaxRecharge() {
      return (
        this.$t('Login._MínimoRechare') +
        this.zhifupayments[this.paymentsActive].min_recharge +
        this.$t('Login._MáximoRechare') +
        this.zhifupayments[this.paymentsActive].max_recharge
      );
    },
    payments() {
      payments({}).then(({ data, res, code }) => {
        if (code === 0) {
          this.zhifupaytype = data.pay_type;
          this.zhifupayments = data.list;
          this.showTimer = data.show_timer;
          this.showCpfName = this.zhifupayments[this.paymentsActive].cpf_name;
          this.showCpfNo = this.zhifupayments[this.paymentsActive].cpf_no;
        }
      });
    },
    onMfeCon(index, type, item) {
      this.index = index;
      if (type == 'top') {
        this.paymentsActive = index;
        this.chooseMoney = -1;
        this.showCpfName = this.zhifupayments[this.paymentsActive].cpf_name;
        this.showCpfNo = this.zhifupayments[this.paymentsActive].cpf_no;
      }
      if (type == 'bottom') {
        this.chooseMoney = index;
        this.amount = item[0];
      }
    },
    clearConst() {
      this.amount = '';
    },
    isShmeoteng(type) {
      if(type == 'channel'){
        this.showAllChannel = !this.showAllChannel;
      }else{
        this.showAllGift = !this.showAllGift;
      }
    },
    isFun(name, flag) {
      this[name] = flag;
    },
    // 处理金额输入框失去焦点
    handleAmountBlur() {
      // 原有逻辑：设置焦点状态
      this.isFun('isFocusAmount', false);
      
      // 新增逻辑：寻找最大优惠并设置 chooseMoney
      this.findBestOfferAndSetActive();
    },
    // 寻找最大优惠的项目并设置为激活状态
    findBestOfferAndSetActive() {
      if (!this.amount || this.amount <= 0) {
        return;
      }
      
      const inputAmount = parseFloat(this.amount);
      const config = this.zhifupayments[this.paymentsActive]?.config || [];
      
      let bestIndex = -1;
      let maxBonus = 0;
      
      // 遍历配置列表，找出最大优惠
      config.forEach((item, index) => {
        // item[0] 是最低金额要求，item[1] 是优惠金额
        const minAmount =item[0]? parseInt(item[0]) : 0;
        const bonusAmount = item[1] ? parseInt(item[1]): 0;
        //console.log(`inputAmount:${inputAmount},minAmount:${minAmount}, bonusAmount:${bonusAmount}`);
 
        
        // 如果输入金额满足要求，且优惠更大
        if (inputAmount >= minAmount && bonusAmount > maxBonus) {
          maxBonus = bonusAmount;
          bestIndex = index;
        }
        //console.log(`bestIndex:${bestIndex},maxBonus:${maxBonus}`);

      });
      
      // 设置找到的最优惠项目为激活状态
      this.chooseMoney = bestIndex;
    },
    recharge() {
      let msg = '';
      if (!this.amount || this.amount < 3) {
        msg = this.$t('components._Wrongamount');
      }
      if (!msg && this.showCpfName && !this.cpf_name) {
        msg = this.$t('components._Introduzaoseunomereal');
      }
      if (
        !msg &&
        this.showCpfNo &&
        (!this.cpf_no || this.cpf_no.length != 11)
      ) {
        msg = this.$t('components._IntroduzadoCPF');
      }
      if (msg) {
        Toast.fail({
          message: this.myLineBreaks(msg),
          duration: 0
        });
        setTimeout(() => {
          Toast.clear();
        }, 1000);
        return false;
      }

      recharge({
        amount: this.amount,
        have_bonus:this.have_bonus ? 1 : 0,
        payment_id: this.zhifupayments[this.paymentsActive].id,
        cpf_name: this.showCpfName ? this.cpf_name : '',
        cpf_no: this.showCpfNo ? this.cpf_no : ''
      }).then(({ msg, code, data }) => {
        if (code == 0) {
          if (data.url) {
            Toast.success({
              message: this.myLineBreaks(this.$t('components._paymentpage')),
              duration: 0
            });
            setTimeout(() => {
              Toast.clear();
            }, 5000);
            window.open(data.url, '_self');
          } else {
            this.$store.commit('publicFun', ['PaymentInformation', data]);
            this.$store.commit('publicFun', ['isPayment', true]);
            if (this.showCpfNo) {
              this.$vuex('rechargeCpf', {
                name: this.cpf_name,
                cpf: this.cpf_no
              });
            }
          }
        } else {
          Toast.loading({
            message: this.myLineBreaks(msg),
            duration: 0
          });
          setTimeout(() => {
            Toast.clear();
          }, 1000);
        }
      });
    },
    onClickLeft() {
      this.isRecordDetails = false;
      // this.isRecord=false
      this.$store.commit('isDeposit', false);
    },
    doJump(url) {
      if (url == 'suporte') {
        this.openUrl('notice');
        this.$store.commit('isDeposit', false);
      }else{

      }
      
    }
  }
};
</script>
<style>
.promote .van-nav-bar__title {
  font-size: 0.32rem;
  color: var(--cms-text-color-primary);
  line-height: normal;
}
.scroll-container {
  overflow-x: hidden !important; /* 隐藏横向滚动条 */
  /*overflow-y: auto !important;  开启垂直滚动条 */
  /*-ms-overflow-style:scroll;  针对IE、Edge浏览器 */
  /*scrollbar-width: auto;  针对Firefox浏览器 */
}
.scroll-container::-webkit-scrollbar {
  width: 0.06rem;
  height: 1rem;
  display: block;
  position: relative;
}
/* 自定义滚动条轨道 */
.scroll-container::-webkit-scrollbar-track {
  background: transparent; /* 设置轨道的背景颜色 */
}
/* 自定义滚动条的滑块（thumb） */
.scroll-container::-webkit-scrollbar-thumb {
  background: var(--theme-color-line); /* 设置滑块的背景颜色 */
}
/* 当滑块悬停或活动时自定义滚动条的滑块 */
.scroll-container::-webkit-scrollbar-thumb:hover {
  background: #555; /* 设置滑块在悬停状态下的背景颜色 */
}
.login-body {
  font-weight: 400;
}
.login-body.promote .van-nav-bar {
  border-bottom: none;
}
.login-body .van-popup {
  background-color: transparent;
}
.login-body.promote [class*='van-hairline']::after {
  border-bottom: none !important;
}

.login-body .van-tab--active .imageWrap {
  color: var(--theme-primary-color) !important;
}
.foen-yes .van-search {
  display: flex;
  align-items: center;
  border-radius: 0.14rem;
  font-size: 0.22rem;
  height: 0.7rem;
  background-color: var(--theme-main-bg-color);
  border: 1px solid #d9d9d9;
  padding-right: 0.1rem;
  border-color: var(--theme-color-line);
}

.foen-yes .van-checkbox__icon .van-icon {
  border-radius: 0.06rem;
  border-color: var(--theme-color-line);
}

.foen-yes .van-search__content {
  background-color: var(--theme-main-bg-color);
}

.foen-yes .van-checkbox__label {
  display: flex;
  align-items: center;
}

.foen-yes .data-user-agreement {
  color: var(--theme-primary-color);
}

.foen-yes input::-webkit-input-placeholder {
  /* 使用webkit内核的浏览器 */
  color: var(--theme-text-color-placeholder) !important;
  line-height: 0.3rem !important;
  font-size: 0.22rem !important;
  font-weight: 400 !important;
}

.foen-yes input:-moz-placeholder {
  /* Firefox版本4-18 */
  color: var(--theme-text-color-placeholder) !important;
  line-height: 0.3rem !important;
  font-size: 0.22rem !important;
  font-weight: 400 !important;
}

.foen-yes input::-moz-placeholder {
  /* Firefox版本19+ */
  color: var(--theme-text-color-placeholder) !important;
  line-height: 0.3rem !important;
  font-size: 0.22rem !important;
  font-weight: 400 !important;
}

.foen-yes input:-ms-input-placeholder {
  /* IE浏览器 */
  color: var(--theme-text-color-placeholder) !important;
  line-height: 0.3rem !important;
  font-size: 0.22rem !important;
  font-weight: 400 !important;
}

.foen-yes .van-field__body input {
  font-size: 0.3rem;
  font-weight: 700;
  color: var(--theme-text-color-darken);
}

.input-active {
  /* var(--theme-primary-color); */
  box-shadow: 0 2px 0 rgba(0, 0, 0, 0.045);
  border: 0.02rem solid var(--theme-filter-active-color) !important;
}

.v0FZl0YCkb_Z5KOXk68M4._max-width .van-dropdown-menu__bar .van-ellipsis {
  color: var(--theme-text-color-darken);
}

.v0FZl0YCkb_Z5KOXk68M4._max-width .van-popup,
.v0FZl0YCkb_Z5KOXk68M4._max-width .van-dropdown-item {
  width: 100%;
}

.v0FZl0YCkb_Z5KOXk68M4._max-width .van-dropdown-item {
  top: 0.8rem !important;
}
</style>
<style scoped>
  :deep(.van-checkbox){
    border-radius: 0.15rem;
    border:0.01rem solid var(--theme-text-color-darken) !important
  }
  :deep(.van-checkbox__icon--checked .van-icon){
    color: var(--theme-main-bg-color) !important;
  }
  :deep(.van-checkbox__icon .van-icon){
        border: none !important;

  }
.conter_tops {
  display: flex;
  align-items: center;
  border-bottom: 0.01rem solid var(--theme-color-line);
}
.conter_tops-cone {
  padding-top: 0.3rem;
  padding-bottom: 0.1rem;
  display: flex;
  align-items: center;
  border-bottom: 0.04rem solid var(--theme-primary-color);
}
.conter_tops .JW9l1M000tsWqSNVub_5 {
  margin-left: 0.1rem;
  font-size: 0.28rem;
  color: var(--theme-primary-color);
}
.conter_tops .imageWrap {
  font-size: 0.38rem;
  width: 0.38rem;
  height: 0.38rem;
}
.uKyP975BYTzKm22WhHCb {
  color: var(--theme-primary-color);
  cursor: pointer;
  font-size: 0.24rem;
  font-weight: 400;
  z-index: 9999;
  position: absolute;
  right: 0.3rem;
  top: 0.15rem;
}
.GaL3XJonIwzK4ZeJyCyq {
  background-color: #fff;
  background-image: none;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  -webkit-box-shadow: 0 2px 0 rgba(0, 0, 0, 0.015);
  box-shadow: 0 2px 0 rgba(0, 0, 0, 0.015);
  color: rgba(0, 0, 0, 0.65);
  cursor: pointer;
  display: inline-block;
  font-size: 14px;
  font-weight: 300;
  height: 32px;
  line-height: 1.499;
  padding: 0 15px;
  position: relative;
  text-align: center;
  -ms-touch-action: manipulation;
  touch-action: manipulation;
  -webkit-transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  white-space: nowrap;
}
.GaL3XJonIwzK4ZeJyCyq {
  background-color: var(--theme-primary-color);
  border-color: var(--theme-primary-color);
  font-size: 0.24rem;
  height: 0.7rem;
  width: 100%;
  color: var(--theme-primary-font-color);
  text-shadow: none;
  box-shadow: 0 2px 0 rgba(0, 0, 0, 0.045);
}
.bIfFIphSiWAweeD39Bmu {
  font-size: 0.24rem;
  padding-top: 0.3rem;
  margin-bottom: 0.2rem;
  color: var(--theme-text-color-darken);
}
.JqPcJmLp1BV_0pDIq65q {
  font-size: 0.24rem !important;
  color: var(--theme-text-color-darken);
  display: flex;
  padding-top: 0.2rem;
  margin-bottom: 0.2rem;
  word-break: break-all;
  font-weight: 400;
}

.ceiktj0nGFZYA3JZ65zu {
  display: grid;
  gap: .2rem;
  grid-template-columns: repeat(4, 1fr);
  margin-bottom: 0.2rem !important;
}
.ceiktj0nGFZYA3JZ65zuchose {
  border: thin solid var(--theme-mine-icon-color) !important;
}
.uh6csli2MHzFz87__Phx {
  height: 0.32rem;
  left: var(--cu-left);
  position: absolute;
  right: var(--cu-right);
  top: var(--cu-top);
  width: -webkit-fit-content;
  width: -moz-fit-content;
  width: fit-content;
  z-index: 100;
}

.uh6csli2MHzFz87__Phx p {
  margin-bottom: 0;
}

.uh6csli2MHzFz87__Phx .YiNQnpSJUes7u5sqBZhp {
  border-bottom: 0.07rem solid transparent;
  border-left: 0.07rem solid var(--theme-secondary-color-error);
  border-right: 0.07rem solid transparent;
  height: 0;
  width: 0;
}

.uh6csli2MHzFz87__Phx .T5xNMynUJQws22ZME9hV {
  border-bottom: 0.07rem solid transparent;
  border-left: 0.07rem solid transparent;
  border-right: 0.07rem solid var(--theme-secondary-color-error);
  float: right;
}

.uh6csli2MHzFz87__Phx .sNgyWmhVEZVrbSGKDBra {
  background-color: var(--theme-secondary-color-error);
  border-radius: 0.125rem 0.125rem 0.125rem 0;
  color: #fff;
  font-size: 0.14rem;
  height: 0.22rem;
  line-height: 0.22rem;
  padding: 0 0.08rem;
  width: 100%;
}

.uh6csli2MHzFz87__Phx .sNgyWmhVEZVrbSGKDBra:lang(my_MM) {
  height: 0.26rem;
}

.uh6csli2MHzFz87__Phx .CmN8CVsfet8ieqBIT7mi {
  color: #ff0;
}

.uh6csli2MHzFz87__Phx .nc_NIDTLmXeUSFFfADOl {
  border-radius: 0.125rem 0.125rem 0 0.125rem;
}
.ceiktj0nGFZYA3JZ65zu li {
  position: absolute;
  -ms-flex-align: center;
  -ms-flex-pack: center;
  align-items: center;
  background-color: var(--theme-main-bg-color);
  /* border: thin solid var(--theme-color-line); */
  border-radius: 0.1rem;
  color: var(--theme-text-color);
  height: 0.79rem;
  cursor: pointer;
  display: -ms-flexbox;
  display: flex;
  font-size: 0.22rem;
  justify-content: center;
  /* margin: 0 3.5% 0.2rem 0; */
  position: relative;
  box-sizing: border-box;
  text-align: center;
  /* width: 22.3%; */
  word-break: break-all;
}
.ceiktj0nGFZYA3JZ65zu li:nth-child(3n) {
  /* margin-right: 3.5% !important; */
}
.ceiktj0nGFZYA3JZ65zu li:nth-child(4n) {
  margin-right: 0;
}
.Recharge-box {
  position: relative;
  background-color: var(--theme-main-bg-color);
  height: calc(var(--vh, 1vh) * 100 - 0.9rem);
  overflow: hidden;
  border-radius: 0.2rem 0.2rem 0 0;
  display: flex;
  flex-direction: column;
}

.e8siic_ICXmLcAr12pgU {
  /* height: 100vh !important; */
  height: 95%;
  padding: 0.2rem;
  overflow: scroll;
}

.e8siic_ICXmLcAr12pgU .qlHv4PpCNi4nGFQLaRq0 li {
  height: 0.7rem;
  margin: 0 3.5% 0.2rem 0;
  width: 31%;
}

.e8siic_ICXmLcAr12pgU {
  height: 95%;
  padding: 0.2rem 0.2rem 0;
}

.e8siic_ICXmLcAr12pgU dl,
.e8siic_ICXmLcAr12pgU ol,
.e8siic_ICXmLcAr12pgU p,
.e8siic_ICXmLcAr12pgU ul {
  margin-bottom: 0;
}

.e8siic_ICXmLcAr12pgU .qlHv4PpCNi4nGFQLaRq0 {
  border-bottom: thin solid var(--theme-color-line);
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  padding-bottom: 0;
}

.e8siic_ICXmLcAr12pgU .qlHv4PpCNi4nGFQLaRq0 li {
  background-color: var(--theme-main-bg-color);
  border: thin solid var(--theme-color-line);
  border-radius: 0.1rem;
  cursor: pointer;
  height: 0.6rem;
  margin: 0 2.6% 0.2rem 0;
  position: relative;
}

.e8siic_ICXmLcAr12pgU .qlHv4PpCNi4nGFQLaRq0 li ._vmaNbC7tMMJ99x929N7 {
  -ms-flex-align: center;
  align-items: center;
  display: -ms-flexbox;
  display: flex;
  height: 100%;
  width: 100%;
  padding: 0;
  margin: 0;
}

._vmaNbC7tMMJ99x929N7 .contee {
  width: 100%;
  height: 100%;
}

.e8siic_ICXmLcAr12pgU .qlHv4PpCNi4nGFQLaRq0 li ._vmaNbC7tMMJ99x929N7 dt {
  border-radius: 0.05rem;
  height: 0.44rem;
  margin-left: 0.08rem;
  margin-right: 0.03rem;
  overflow: hidden;
  width: 0.44rem;
  display: flex;
  align-items: center;
}

.e8siic_ICXmLcAr12pgU .qlHv4PpCNi4nGFQLaRq0 li ._vmaNbC7tMMJ99x929N7 dd {
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  -ms-flex-align: center;
  -ms-flex-pack: center;
  align-items: center;
  color: var(--theme-text-color-darken);
  display: -webkit-box;
  -ms-flex: 1;
  flex: 1;
  font-size: 0.24rem;
  justify-content: center;
  margin: 0;
  overflow: hidden;
  text-align: center;
  text-overflow: ellipsis;
  vertical-align: middle;
  word-break: break-all;
}
.NvAx2rtSlQ6tCymRPyMO {
  border-right: 0.02rem solid var(--theme-primary-color);
  border-top: 0.02rem solid var(--theme-primary-color);
  height: 0.14rem;
  width: 0.14rem;
  transform: rotate(135deg) translateY(0.07rem);
}

._ojhUxKWGyFdJIV2Lodx {
  bottom: -0.01rem;
  display: block;
  height: 0.3rem;
  line-height: 0.3rem;
  overflow: hidden;
  position: absolute;
  right: -0.01rem;
  width: 0.3rem;
}

.e8siic_ICXmLcAr12pgU
  .qlHv4PpCNi4nGFQLaRq0
  li
  ._vmaNbC7tMMJ99x929N7
  dd:not(:lang(zh_CN)) {
  line-height: 1.2;
}

.e8siic_ICXmLcAr12pgU
  .qlHv4PpCNi4nGFQLaRq0
  li
  ._vmaNbC7tMMJ99x929N7
  .B6CbnR9usOF_CMi5m8BU {
  vertical-align: baseline;
  vertical-align: initial;
}

.e8siic_ICXmLcAr12pgU .qlHv4PpCNi4nGFQLaRq0 li .r1QnBDk2QnzYN6t7hweu {
  max-width: 100%;
}

.e8siic_ICXmLcAr12pgU
  .qlHv4PpCNi4nGFQLaRq0
  li
  .r1QnBDk2QnzYN6t7hweu
  p:first-child {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.e8siic_ICXmLcAr12pgU .qlHv4PpCNi4nGFQLaRq0 li.tivA24cSEjfykc3h2PmN {
  border: thin solid var(--theme-filter-active-color);
}

.e8siic_ICXmLcAr12pgU
  .qlHv4PpCNi4nGFQLaRq0
  li.tivA24cSEjfykc3h2PmN
  ._vmaNbC7tMMJ99x929N7
  dd {
  color: var(--theme-primary-color);
}

.e8siic_ICXmLcAr12pgU
  .qlHv4PpCNi4nGFQLaRq0
  li.tivA24cSEjfykc3h2PmN
  .subscript
  .bg {
  color: var(--theme-filter-active-color);
}

.subscript .duihap {
  bottom: 0.04rem;
  color: var(--theme-active-gou-color);
  color: var(--theme-web_filter_gou);
  height: 0.096rem;
  position: absolute;
  right: 0.04rem;
  width: 0.125rem;
}

.e8siic_ICXmLcAr12pgU .qlHv4PpCNi4nGFQLaRq0[hidden-border='true'] {
  border: none;
}

.e8siic_ICXmLcAr12pgU .nzTOTuxf3_9m0mLVwasZ,
.e8siic_ICXmLcAr12pgU .pvCBPwt_79HNmWpTTNiz {
  -ms-flex-align: center;
  align-items: center;
  border-bottom: 0.01rem solid var(--theme-color-line);
  color: var(--theme-primary-color);
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  padding: 0.3rem 0;
}

.e8siic_ICXmLcAr12pgU .nzTOTuxf3_9m0mLVwasZ .fsw7N42rWkHNfzNqMy1j,
.e8siic_ICXmLcAr12pgU .pvCBPwt_79HNmWpTTNiz .fsw7N42rWkHNfzNqMy1j {
  color: var(--theme-text-color-lighten);
  font-size: 0.2rem;
}

.e8siic_ICXmLcAr12pgU .nzTOTuxf3_9m0mLVwasZ .ant-btn,
.e8siic_ICXmLcAr12pgU .pvCBPwt_79HNmWpTTNiz .ant-btn {
  font-size: 0.16rem;
  height: 0.4rem;
  width: auto;
}

.e8siic_ICXmLcAr12pgU .rXTWRQZAf8yCWjE6oWvd {
  color: var(--theme-text-color-darken);
  font-size: 0.24rem;
  margin: 0 0.2rem;
  white-space: nowrap;
}

.e8siic_ICXmLcAr12pgU .UXb8kWynLNKjn7rKh5An {
  color: var(--theme-primary-color);
  cursor: pointer;
  font-size: 0.18rem;
  margin-left: 0.06rem;
}

.e8siic_ICXmLcAr12pgU .BKfC6Trv2S3lop0AQYI1 {
  border-bottom: thin solid var(--theme-color-line);
  color: var(--theme-primary-color);
  cursor: pointer;
  font-size: 0.18rem;
  height: 0.46rem;
  line-height: 0.26rem;
  padding-bottom: 0.2rem 0;
  text-align: center;
}
.e8siic_ICXmLcAr12pgU .BKfC6Trv2S3lop0AQYI1 div {
  display: flex;
  align-items: center;
}

.e8siic_ICXmLcAr12pgU .BKfC6Trv2S3lop0AQYI1 p span {
  display: inline-block;
}

.e8siic_ICXmLcAr12pgU .BKfC6Trv2S3lop0AQYI1 p span:first-child {
  margin-right: 0.14rem;
  font-size: 0.24rem;
}

.e8siic_ICXmLcAr12pgU .CJ8dBGR3Ac2Lugo_wuSA {
  border-bottom: thin solid var(--theme-color-line);
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  padding: 0.3rem 0 0.1rem;
}

.e8siic_ICXmLcAr12pgU .CJ8dBGR3Ac2Lugo_wuSA[data-no-border='true'] {
  border-bottom: 0;
}

.e8siic_ICXmLcAr12pgU .CJ8dBGR3Ac2Lugo_wuSA li {
  -ms-flex-align: center;
  -ms-flex-pack: center;
  align-items: center;
  background-color: var(--theme-main-bg-color);
  border: thin solid var(--theme-color-line);
  border-radius: 0.1rem;
  color: var(--theme-text-color);
  cursor: pointer;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-direction: column;
  flex-direction: column;
  font-size: 0.18rem;
  justify-content: center;
  margin: 0 3.5% 0.2rem 0;
  min-height: 0.6rem;
  position: relative;
  text-align: center;
  width: 31%;
}

.e8siic_ICXmLcAr12pgU .CJ8dBGR3Ac2Lugo_wuSA li .tool-tips {
  max-width: calc(100% - 0.1rem);
}

.e8siic_ICXmLcAr12pgU .CJ8dBGR3Ac2Lugo_wuSA li .tool-tips .tool-tips-box {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: auto;
}

.e8siic_ICXmLcAr12pgU li:nth-child(3n) {
  margin-right: 0;
}

.e8siic_ICXmLcAr12pgU .CJ8dBGR3Ac2Lugo_wuSA li.tivA24cSEjfykc3h2PmN {
  border: thin solid var(--theme-filter-active-color);
  color: var(--theme-primary-color);
}

.e8siic_ICXmLcAr12pgU
  .CJ8dBGR3Ac2Lugo_wuSA
  li.tivA24cSEjfykc3h2PmN
  .subscript
  .bg {
  color: var(--theme-filter-active-color);
}

.e8siic_ICXmLcAr12pgU .CJ8dBGR3Ac2Lugo_wuSA .wVAAg96a2eGRCC_Alfwa {
  font-size: 0.18rem;
  line-height: 1.2;
  overflow: hidden;
  padding: 0 0.08rem;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
}

.e8siic_ICXmLcAr12pgU .CJ8dBGR3Ac2Lugo_wuSA .nGEQ7hYI2RSUGhlcHVRJ {
  margin-right: 3.5%;
  width: 48.25%;
}

.e8siic_ICXmLcAr12pgU .CJ8dBGR3Ac2Lugo_wuSA .nGEQ7hYI2RSUGhlcHVRJ .tool-tips {
  max-width: calc(100% - 0.1rem);
}

.e8siic_ICXmLcAr12pgU
  .CJ8dBGR3Ac2Lugo_wuSA
  .nGEQ7hYI2RSUGhlcHVRJ
  .tool-tips
  .tool-tips-box {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: auto;
}

.e8siic_ICXmLcAr12pgU
  .CJ8dBGR3Ac2Lugo_wuSA
  .nGEQ7hYI2RSUGhlcHVRJ:nth-child(3n) {
  margin-right: 3.5%;
}

.e8siic_ICXmLcAr12pgU
  .CJ8dBGR3Ac2Lugo_wuSA
  .nGEQ7hYI2RSUGhlcHVRJ:nth-child(2n) {
  margin-right: 0;
}

.e8siic_ICXmLcAr12pgU .CJ8dBGR3Ac2Lugo_wuSA .EULSCYGzEf4AdA_oRuQK {
  color: var(--theme-text-color-lighten);
  font-size: 0.16rem;
}

.e8siic_ICXmLcAr12pgU .CJ8dBGR3Ac2Lugo_wuSA .r1QnBDk2QnzYN6t7hweu {
  max-width: 100%;
}

.e8siic_ICXmLcAr12pgU
  .CJ8dBGR3Ac2Lugo_wuSA
  .r1QnBDk2QnzYN6t7hweu
  p:first-child {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.e8siic_ICXmLcAr12pgU .ApwjISqJuDYEGaCYaotN .SmkqAW7NJS55ddEjrHvA {
  -ms-flex-pack: justify;
  color: var(--theme-text-color-darken);
  display: -ms-flexbox;
  display: flex;
  font-size: 0.2rem;
  justify-content: space-between;
  line-height: 0.26rem;
  margin-bottom: 0.2rem !important;
  min-height: 0.26rem;
  position: relative;
}

.e8siic_ICXmLcAr12pgU
  .ApwjISqJuDYEGaCYaotN
  .SmkqAW7NJS55ddEjrHvA
  .bIfFIphSiWAweeD39Bmu {
  -ms-flex: none;
  flex: none;
  font-size: 0.24rem;
}

.e8siic_ICXmLcAr12pgU
  .ApwjISqJuDYEGaCYaotN
  .SmkqAW7NJS55ddEjrHvA
  ._YSEaV7Oyl6HFoCgkJoZ {
  color: var(--theme-text-color-lighten);
  margin-left: 0.2rem;
}

.e8siic_ICXmLcAr12pgU
  .ApwjISqJuDYEGaCYaotN
  .SmkqAW7NJS55ddEjrHvA
  ._YSEaV7Oyl6HFoCgkJoZ
  span {
  color: var(--theme-secondary-color-finance);
}

.e8siic_ICXmLcAr12pgU .ApwjISqJuDYEGaCYaotN .LLgG6tYJHHChLlWpQ2aK {
  color: var(--theme-text-color-darken);
  font-size: 0.18rem;
  margin-bottom: 0.05rem;
}

.e8siic_ICXmLcAr12pgU .ApwjISqJuDYEGaCYaotN .t2ii7DT7lea1duaxoXZd {
  color: var(--theme-primary-color);
  cursor: pointer;
  float: right;
}

.e8siic_ICXmLcAr12pgU
  .ApwjISqJuDYEGaCYaotN
  .t2ii7DT7lea1duaxoXZd
  .sXiHSyM9lA1FNhBIbmuo {
  background-color: #fff;
  border: thin solid #999;
  border-radius: 0.1rem;
  bottom: 0.4rem;
  -webkit-box-shadow: 0 0.02rem 0.1rem 0 rgba(0, 0, 0, 0.15);
  box-shadow: 0 0.02rem 0.1rem 0 rgba(0, 0, 0, 0.15);
  color: #333;
  font-size: 0.22rem;
  padding: 0.2rem;
  position: absolute;
  right: 0;
  text-align: center;
  width: 100%;
  z-index: 101;
}

.e8siic_ICXmLcAr12pgU
  .ApwjISqJuDYEGaCYaotN
  .t2ii7DT7lea1duaxoXZd
  .sXiHSyM9lA1FNhBIbmuo:after {
  background-color: #fff;
  border-color: #999;
  border-style: solid;
  border-width: 0 0 0.01rem 0.01rem;
  bottom: -0.1rem;
  content: '';
  height: 0.2rem;
  position: absolute;
  right: 0.12rem;
  -webkit-transform: translateX(-50%) rotate(-45deg);
  transform: translateX(-50%) rotate(-45deg);
  width: 0.2rem;
  z-index: 2;
}

.e8siic_ICXmLcAr12pgU
  .ApwjISqJuDYEGaCYaotN
  .t2ii7DT7lea1duaxoXZd
  .sXiHSyM9lA1FNhBIbmuo:lang(my_MM) {
  line-height: 0.32rem;
}

.e8siic_ICXmLcAr12pgU .ApwjISqJuDYEGaCYaotN .EeD_klL7wmLX7vgxX6VA,
.e8siic_ICXmLcAr12pgU .ApwjISqJuDYEGaCYaotN .aFSrp88DK9sQdBbxx4Ie,
.e8siic_ICXmLcAr12pgU .ApwjISqJuDYEGaCYaotN .ok4RCdndQu2JV3GMn4VD {
  padding: 0.4rem 0;
}

.e8siic_ICXmLcAr12pgU
  .ApwjISqJuDYEGaCYaotN
  .EeD_klL7wmLX7vgxX6VA
  .eB3l_JiD0MaOl9Fyxzk7,
.e8siic_ICXmLcAr12pgU
  .ApwjISqJuDYEGaCYaotN
  .aFSrp88DK9sQdBbxx4Ie
  .eB3l_JiD0MaOl9Fyxzk7,
.e8siic_ICXmLcAr12pgU
  .ApwjISqJuDYEGaCYaotN
  .ok4RCdndQu2JV3GMn4VD
  .eB3l_JiD0MaOl9Fyxzk7 {
  display: -ms-flexbox;
  display: flex;
  position: relative;
}

.e8siic_ICXmLcAr12pgU
  .ApwjISqJuDYEGaCYaotN
  .EeD_klL7wmLX7vgxX6VA
  .eB3l_JiD0MaOl9Fyxzk7
  .LRfaqCxGGdXMNmz8w0OP,
.e8siic_ICXmLcAr12pgU
  .ApwjISqJuDYEGaCYaotN
  .aFSrp88DK9sQdBbxx4Ie
  .eB3l_JiD0MaOl9Fyxzk7
  .LRfaqCxGGdXMNmz8w0OP,
.e8siic_ICXmLcAr12pgU
  .ApwjISqJuDYEGaCYaotN
  .ok4RCdndQu2JV3GMn4VD
  .eB3l_JiD0MaOl9Fyxzk7
  .LRfaqCxGGdXMNmz8w0OP {
  -ms-flex: 1;
  flex: 1;
}

.e8siic_ICXmLcAr12pgU
  .ApwjISqJuDYEGaCYaotN
  .EeD_klL7wmLX7vgxX6VA
  .eB3l_JiD0MaOl9Fyxzk7
  input[type='number']::-webkit-inner-spin-button,
.e8siic_ICXmLcAr12pgU
  .ApwjISqJuDYEGaCYaotN
  .EeD_klL7wmLX7vgxX6VA
  .eB3l_JiD0MaOl9Fyxzk7
  input[type='number']::-webkit-outer-spin-button,
.e8siic_ICXmLcAr12pgU
  .ApwjISqJuDYEGaCYaotN
  .aFSrp88DK9sQdBbxx4Ie
  .eB3l_JiD0MaOl9Fyxzk7
  input[type='number']::-webkit-inner-spin-button,
.e8siic_ICXmLcAr12pgU
  .ApwjISqJuDYEGaCYaotN
  .aFSrp88DK9sQdBbxx4Ie
  .eB3l_JiD0MaOl9Fyxzk7
  input[type='number']::-webkit-outer-spin-button,
.e8siic_ICXmLcAr12pgU
  .ApwjISqJuDYEGaCYaotN
  .ok4RCdndQu2JV3GMn4VD
  .eB3l_JiD0MaOl9Fyxzk7
  input[type='number']::-webkit-inner-spin-button,
.e8siic_ICXmLcAr12pgU
  .ApwjISqJuDYEGaCYaotN
  .ok4RCdndQu2JV3GMn4VD
  .eB3l_JiD0MaOl9Fyxzk7
  input[type='number']::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.e8siic_ICXmLcAr12pgU
  .ApwjISqJuDYEGaCYaotN
  .EeD_klL7wmLX7vgxX6VA
  .LRfaqCxGGdXMNmz8w0OP,
.e8siic_ICXmLcAr12pgU
  .ApwjISqJuDYEGaCYaotN
  .aFSrp88DK9sQdBbxx4Ie
  .LRfaqCxGGdXMNmz8w0OP,
.e8siic_ICXmLcAr12pgU
  .ApwjISqJuDYEGaCYaotN
  .ok4RCdndQu2JV3GMn4VD
  .LRfaqCxGGdXMNmz8w0OP {
  border-radius: 0.1rem;
  font-size: 0.2rem;
  height: 0.6rem;
  width: 100%;
}

.e8siic_ICXmLcAr12pgU
  .ApwjISqJuDYEGaCYaotN
  .EeD_klL7wmLX7vgxX6VA
  .LRfaqCxGGdXMNmz8w0OP
  input,
.e8siic_ICXmLcAr12pgU
  .ApwjISqJuDYEGaCYaotN
  .aFSrp88DK9sQdBbxx4Ie
  .LRfaqCxGGdXMNmz8w0OP
  input,
.e8siic_ICXmLcAr12pgU
  .ApwjISqJuDYEGaCYaotN
  .ok4RCdndQu2JV3GMn4VD
  .LRfaqCxGGdXMNmz8w0OP
  input {
  border-radius: 0.1rem;
  font-size: 0.2rem;
  height: 100%;
}

.e8siic_ICXmLcAr12pgU
  .ApwjISqJuDYEGaCYaotN
  .EeD_klL7wmLX7vgxX6VA
  .LRfaqCxGGdXMNmz8w0OP
  input::-webkit-input-placeholder,
.e8siic_ICXmLcAr12pgU
  .ApwjISqJuDYEGaCYaotN
  .aFSrp88DK9sQdBbxx4Ie
  .LRfaqCxGGdXMNmz8w0OP
  input::-webkit-input-placeholder,
.e8siic_ICXmLcAr12pgU
  .ApwjISqJuDYEGaCYaotN
  .ok4RCdndQu2JV3GMn4VD
  .LRfaqCxGGdXMNmz8w0OP
  input::-webkit-input-placeholder {
  max-width: 85%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.e8siic_ICXmLcAr12pgU
  .ApwjISqJuDYEGaCYaotN
  .EeD_klL7wmLX7vgxX6VA
  .LRfaqCxGGdXMNmz8w0OP
  input::-moz-placeholder,
.e8siic_ICXmLcAr12pgU
  .ApwjISqJuDYEGaCYaotN
  .aFSrp88DK9sQdBbxx4Ie
  .LRfaqCxGGdXMNmz8w0OP
  input::-moz-placeholder,
.e8siic_ICXmLcAr12pgU
  .ApwjISqJuDYEGaCYaotN
  .ok4RCdndQu2JV3GMn4VD
  .LRfaqCxGGdXMNmz8w0OP
  input::-moz-placeholder {
  max-width: 85%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.e8siic_ICXmLcAr12pgU
  .ApwjISqJuDYEGaCYaotN
  .EeD_klL7wmLX7vgxX6VA
  .LRfaqCxGGdXMNmz8w0OP
  input:-ms-input-placeholder,
.e8siic_ICXmLcAr12pgU
  .ApwjISqJuDYEGaCYaotN
  .aFSrp88DK9sQdBbxx4Ie
  .LRfaqCxGGdXMNmz8w0OP
  input:-ms-input-placeholder,
.e8siic_ICXmLcAr12pgU
  .ApwjISqJuDYEGaCYaotN
  .ok4RCdndQu2JV3GMn4VD
  .LRfaqCxGGdXMNmz8w0OP
  input:-ms-input-placeholder {
  max-width: 85%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.e8siic_ICXmLcAr12pgU
  .ApwjISqJuDYEGaCYaotN
  .EeD_klL7wmLX7vgxX6VA
  .LRfaqCxGGdXMNmz8w0OP
  input[disabled],
.e8siic_ICXmLcAr12pgU
  .ApwjISqJuDYEGaCYaotN
  .aFSrp88DK9sQdBbxx4Ie
  .LRfaqCxGGdXMNmz8w0OP
  input[disabled],
.e8siic_ICXmLcAr12pgU
  .ApwjISqJuDYEGaCYaotN
  .ok4RCdndQu2JV3GMn4VD
  .LRfaqCxGGdXMNmz8w0OP
  input[disabled] {
  background-color: var(--theme-main-bg-color) !important;
  color: var(--theme-text-color);
}

.e8siic_ICXmLcAr12pgU
  .ApwjISqJuDYEGaCYaotN
  .EeD_klL7wmLX7vgxX6VA
  .LRfaqCxGGdXMNmz8w0OP
  .ant-input-prefix
  + input,
.e8siic_ICXmLcAr12pgU
  .ApwjISqJuDYEGaCYaotN
  .aFSrp88DK9sQdBbxx4Ie
  .LRfaqCxGGdXMNmz8w0OP
  .ant-input-prefix
  + input,
.e8siic_ICXmLcAr12pgU
  .ApwjISqJuDYEGaCYaotN
  .ok4RCdndQu2JV3GMn4VD
  .LRfaqCxGGdXMNmz8w0OP
  .ant-input-prefix
  + input {
  color: var(--theme-text-color-darken);
  font-size: 0.24rem;
  padding-left: 0.65rem;
}

.e8siic_ICXmLcAr12pgU
  .ApwjISqJuDYEGaCYaotN
  .EeD_klL7wmLX7vgxX6VA
  .LRfaqCxGGdXMNmz8w0OP
  .ant-input-prefix
  + input::-webkit-input-placeholder,
.e8siic_ICXmLcAr12pgU
  .ApwjISqJuDYEGaCYaotN
  .aFSrp88DK9sQdBbxx4Ie
  .LRfaqCxGGdXMNmz8w0OP
  .ant-input-prefix
  + input::-webkit-input-placeholder,
.e8siic_ICXmLcAr12pgU
  .ApwjISqJuDYEGaCYaotN
  .ok4RCdndQu2JV3GMn4VD
  .LRfaqCxGGdXMNmz8w0OP
  .ant-input-prefix
  + input::-webkit-input-placeholder {
  font-size: 0.18rem;
  position: relative;
  top: 0;
}

.e8siic_ICXmLcAr12pgU
  .ApwjISqJuDYEGaCYaotN
  .EeD_klL7wmLX7vgxX6VA
  .LRfaqCxGGdXMNmz8w0OP
  .ant-input-prefix
  + input::-moz-placeholder,
.e8siic_ICXmLcAr12pgU
  .ApwjISqJuDYEGaCYaotN
  .aFSrp88DK9sQdBbxx4Ie
  .LRfaqCxGGdXMNmz8w0OP
  .ant-input-prefix
  + input::-moz-placeholder,
.e8siic_ICXmLcAr12pgU
  .ApwjISqJuDYEGaCYaotN
  .ok4RCdndQu2JV3GMn4VD
  .LRfaqCxGGdXMNmz8w0OP
  .ant-input-prefix
  + input::-moz-placeholder {
  font-size: 0.18rem;
  position: relative;
  top: 0;
}

.e8siic_ICXmLcAr12pgU
  .ApwjISqJuDYEGaCYaotN
  .EeD_klL7wmLX7vgxX6VA
  .LRfaqCxGGdXMNmz8w0OP
  .ant-input-prefix
  + input:-ms-input-placeholder,
.e8siic_ICXmLcAr12pgU
  .ApwjISqJuDYEGaCYaotN
  .aFSrp88DK9sQdBbxx4Ie
  .LRfaqCxGGdXMNmz8w0OP
  .ant-input-prefix
  + input:-ms-input-placeholder,
.e8siic_ICXmLcAr12pgU
  .ApwjISqJuDYEGaCYaotN
  .ok4RCdndQu2JV3GMn4VD
  .LRfaqCxGGdXMNmz8w0OP
  .ant-input-prefix
  + input:-ms-input-placeholder {
  font-size: 0.18rem;
  position: relative;
  top: 0;
}

.e8siic_ICXmLcAr12pgU
  .ApwjISqJuDYEGaCYaotN
  .EeD_klL7wmLX7vgxX6VA
  .LRfaqCxGGdXMNmz8w0OP
  .ant-input-prefix,
.e8siic_ICXmLcAr12pgU
  .ApwjISqJuDYEGaCYaotN
  .aFSrp88DK9sQdBbxx4Ie
  .LRfaqCxGGdXMNmz8w0OP
  .ant-input-prefix,
.e8siic_ICXmLcAr12pgU
  .ApwjISqJuDYEGaCYaotN
  .ok4RCdndQu2JV3GMn4VD
  .LRfaqCxGGdXMNmz8w0OP
  .ant-input-prefix {
  left: 0.22rem;
}

.e8siic_ICXmLcAr12pgU
  .ApwjISqJuDYEGaCYaotN
  .EeD_klL7wmLX7vgxX6VA
  .LRfaqCxGGdXMNmz8w0OP
  input
  + .ant-input-suffix
  svg,
.e8siic_ICXmLcAr12pgU
  .ApwjISqJuDYEGaCYaotN
  .aFSrp88DK9sQdBbxx4Ie
  .LRfaqCxGGdXMNmz8w0OP
  input
  + .ant-input-suffix
  svg,
.e8siic_ICXmLcAr12pgU
  .ApwjISqJuDYEGaCYaotN
  .ok4RCdndQu2JV3GMn4VD
  .LRfaqCxGGdXMNmz8w0OP
  input
  + .ant-input-suffix
  svg {
  font-size: 0.28rem;
}

.e8siic_ICXmLcAr12pgU
  .ApwjISqJuDYEGaCYaotN
  .EeD_klL7wmLX7vgxX6VA
  .LRfaqCxGGdXMNmz8w0OP
  .ant-input:not(:last-child),
.e8siic_ICXmLcAr12pgU
  .ApwjISqJuDYEGaCYaotN
  .aFSrp88DK9sQdBbxx4Ie
  .LRfaqCxGGdXMNmz8w0OP
  .ant-input:not(:last-child),
.e8siic_ICXmLcAr12pgU
  .ApwjISqJuDYEGaCYaotN
  .ok4RCdndQu2JV3GMn4VD
  .LRfaqCxGGdXMNmz8w0OP
  .ant-input:not(:last-child) {
  padding-right: 0.5rem;
}

.e8siic_ICXmLcAr12pgU
  .ApwjISqJuDYEGaCYaotN
  .EeD_klL7wmLX7vgxX6VA
  .vXlgh13Ofk_pSY4ppCmO
  .ant-input-prefix
  + input,
.e8siic_ICXmLcAr12pgU
  .ApwjISqJuDYEGaCYaotN
  .aFSrp88DK9sQdBbxx4Ie
  .vXlgh13Ofk_pSY4ppCmO
  .ant-input-prefix
  + input,
.e8siic_ICXmLcAr12pgU
  .ApwjISqJuDYEGaCYaotN
  .ok4RCdndQu2JV3GMn4VD
  .vXlgh13Ofk_pSY4ppCmO
  .ant-input-prefix
  + input {
  font-size: 0.18rem;
}

.e8siic_ICXmLcAr12pgU
  .ApwjISqJuDYEGaCYaotN
  .EeD_klL7wmLX7vgxX6VA
  .vXlgh13Ofk_pSY4ppCmO
  .ant-input-prefix,
.e8siic_ICXmLcAr12pgU
  .ApwjISqJuDYEGaCYaotN
  .aFSrp88DK9sQdBbxx4Ie
  .vXlgh13Ofk_pSY4ppCmO
  .ant-input-prefix,
.e8siic_ICXmLcAr12pgU
  .ApwjISqJuDYEGaCYaotN
  .ok4RCdndQu2JV3GMn4VD
  .vXlgh13Ofk_pSY4ppCmO
  .ant-input-prefix {
  color: var(--theme-text-color-lighten);
}

.e8siic_ICXmLcAr12pgU
  .ApwjISqJuDYEGaCYaotN
  .EeD_klL7wmLX7vgxX6VA
  .wOoLBu0Ac__QK_aLYKWg
  input,
.e8siic_ICXmLcAr12pgU
  .ApwjISqJuDYEGaCYaotN
  .aFSrp88DK9sQdBbxx4Ie
  .wOoLBu0Ac__QK_aLYKWg
  input,
.e8siic_ICXmLcAr12pgU
  .ApwjISqJuDYEGaCYaotN
  .ok4RCdndQu2JV3GMn4VD
  .wOoLBu0Ac__QK_aLYKWg
  input {
  padding-left: 0.3rem !important;
}

.e8siic_ICXmLcAr12pgU
  .ApwjISqJuDYEGaCYaotN
  .EeD_klL7wmLX7vgxX6VA
  .wOoLBu0Ac__QK_aLYKWg
  .ant-input-prefix,
.e8siic_ICXmLcAr12pgU
  .ApwjISqJuDYEGaCYaotN
  .aFSrp88DK9sQdBbxx4Ie
  .wOoLBu0Ac__QK_aLYKWg
  .ant-input-prefix,
.e8siic_ICXmLcAr12pgU
  .ApwjISqJuDYEGaCYaotN
  .ok4RCdndQu2JV3GMn4VD
  .wOoLBu0Ac__QK_aLYKWg
  .ant-input-prefix {
  left: 0.1rem;
}

.e8siic_ICXmLcAr12pgU
  .ApwjISqJuDYEGaCYaotN
  .EeD_klL7wmLX7vgxX6VA
  .dJ9nVMUpUeToPZJnQuBQ:last-of-type,
.e8siic_ICXmLcAr12pgU
  .ApwjISqJuDYEGaCYaotN
  .aFSrp88DK9sQdBbxx4Ie
  .dJ9nVMUpUeToPZJnQuBQ:last-of-type,
.e8siic_ICXmLcAr12pgU
  .ApwjISqJuDYEGaCYaotN
  .ok4RCdndQu2JV3GMn4VD
  .dJ9nVMUpUeToPZJnQuBQ:last-of-type {
  margin-bottom: 0;
}

.e8siic_ICXmLcAr12pgU
  .ApwjISqJuDYEGaCYaotN
  .EeD_klL7wmLX7vgxX6VA
  .uYhwAcPorC0IbdXe9xay,
.e8siic_ICXmLcAr12pgU
  .ApwjISqJuDYEGaCYaotN
  .aFSrp88DK9sQdBbxx4Ie
  .uYhwAcPorC0IbdXe9xay,
.e8siic_ICXmLcAr12pgU
  .ApwjISqJuDYEGaCYaotN
  .ok4RCdndQu2JV3GMn4VD
  .uYhwAcPorC0IbdXe9xay {
  color: var(--theme-text-color-darken);
  font-size: 0.2rem;
}

.e8siic_ICXmLcAr12pgU
  .ApwjISqJuDYEGaCYaotN
  .EeD_klL7wmLX7vgxX6VA
  .D3F5Sl3EJv8kt6Wgakkp,
.e8siic_ICXmLcAr12pgU
  .ApwjISqJuDYEGaCYaotN
  .aFSrp88DK9sQdBbxx4Ie
  .D3F5Sl3EJv8kt6Wgakkp,
.e8siic_ICXmLcAr12pgU
  .ApwjISqJuDYEGaCYaotN
  .ok4RCdndQu2JV3GMn4VD
  .D3F5Sl3EJv8kt6Wgakkp {
  -ms-flex-align: center;
  -ms-flex-pack: center;
  align-items: center;
  background-color: var(--theme-main-bg-color);
  border: thin solid var(--theme-color-line);
  border-radius: 0.1rem;
  cursor: pointer;
  display: -ms-flexbox;
  display: flex;
  height: 0.6rem;
  justify-content: center;
  margin-left: 0.2rem;
  width: 0.65rem;
}

.e8siic_ICXmLcAr12pgU
  .ApwjISqJuDYEGaCYaotN
  .EeD_klL7wmLX7vgxX6VA
  .D3F5Sl3EJv8kt6Wgakkp
  .ZAcvGhX0wQN9bz3z0hI1,
.e8siic_ICXmLcAr12pgU
  .ApwjISqJuDYEGaCYaotN
  .aFSrp88DK9sQdBbxx4Ie
  .D3F5Sl3EJv8kt6Wgakkp
  .ZAcvGhX0wQN9bz3z0hI1,
.e8siic_ICXmLcAr12pgU
  .ApwjISqJuDYEGaCYaotN
  .ok4RCdndQu2JV3GMn4VD
  .D3F5Sl3EJv8kt6Wgakkp
  .ZAcvGhX0wQN9bz3z0hI1 {
  color: var(--theme-primary-color);
  font-size: 0.3rem;
}

.e8siic_ICXmLcAr12pgU
  .ApwjISqJuDYEGaCYaotN
  .EeD_klL7wmLX7vgxX6VA
  .D3F5Sl3EJv8kt6Wgakkp
  .sXiHSyM9lA1FNhBIbmuo,
.e8siic_ICXmLcAr12pgU
  .ApwjISqJuDYEGaCYaotN
  .aFSrp88DK9sQdBbxx4Ie
  .D3F5Sl3EJv8kt6Wgakkp
  .sXiHSyM9lA1FNhBIbmuo,
.e8siic_ICXmLcAr12pgU
  .ApwjISqJuDYEGaCYaotN
  .ok4RCdndQu2JV3GMn4VD
  .D3F5Sl3EJv8kt6Wgakkp
  .sXiHSyM9lA1FNhBIbmuo {
  background-color: #fff;
  border: thin solid #999;
  border-radius: 0.1rem;
  bottom: 0.6rem;
  -webkit-box-shadow: 0 0.02rem 0.1rem 0 rgba(0, 0, 0, 0.15);
  box-shadow: 0 0.02rem 0.1rem 0 rgba(0, 0, 0, 0.15);
  color: #333;
  font-size: 0.22rem;
  line-height: 0.26rem;
  padding: 0.2rem;
  position: absolute;
  right: 0;
  text-align: center;
  width: 100%;
  z-index: 101;
}

.e8siic_ICXmLcAr12pgU
  .ApwjISqJuDYEGaCYaotN
  .EeD_klL7wmLX7vgxX6VA
  .D3F5Sl3EJv8kt6Wgakkp
  .sXiHSyM9lA1FNhBIbmuo:after,
.e8siic_ICXmLcAr12pgU
  .ApwjISqJuDYEGaCYaotN
  .aFSrp88DK9sQdBbxx4Ie
  .D3F5Sl3EJv8kt6Wgakkp
  .sXiHSyM9lA1FNhBIbmuo:after,
.e8siic_ICXmLcAr12pgU
  .ApwjISqJuDYEGaCYaotN
  .ok4RCdndQu2JV3GMn4VD
  .D3F5Sl3EJv8kt6Wgakkp
  .sXiHSyM9lA1FNhBIbmuo:after {
  background-color: #fff;
  border-color: #999;
  border-style: solid;
  border-width: 0 0 0.01rem 0.01rem;
  bottom: -0.1rem;
  content: '';
  height: 0.2rem;
  position: absolute;
  right: 0.12rem;
  -webkit-transform: translateX(-50%) rotate(-45deg);
  transform: translateX(-50%) rotate(-45deg);
  width: 0.2rem;
  z-index: 2;
}

.e8siic_ICXmLcAr12pgU
  .ApwjISqJuDYEGaCYaotN
  .EeD_klL7wmLX7vgxX6VA
  .D3F5Sl3EJv8kt6Wgakkp
  .sXiHSyM9lA1FNhBIbmuo:lang(my_MM),
.e8siic_ICXmLcAr12pgU
  .ApwjISqJuDYEGaCYaotN
  .aFSrp88DK9sQdBbxx4Ie
  .D3F5Sl3EJv8kt6Wgakkp
  .sXiHSyM9lA1FNhBIbmuo:lang(my_MM),
.e8siic_ICXmLcAr12pgU
  .ApwjISqJuDYEGaCYaotN
  .ok4RCdndQu2JV3GMn4VD
  .D3F5Sl3EJv8kt6Wgakkp
  .sXiHSyM9lA1FNhBIbmuo:lang(my_MM) {
  line-height: 0.32rem;
}

.e8siic_ICXmLcAr12pgU
  .ApwjISqJuDYEGaCYaotN
  .EeD_klL7wmLX7vgxX6VA
  .PrRVWLDa8ject9CNjD4w,
.e8siic_ICXmLcAr12pgU
  .ApwjISqJuDYEGaCYaotN
  .aFSrp88DK9sQdBbxx4Ie
  .PrRVWLDa8ject9CNjD4w,
.e8siic_ICXmLcAr12pgU
  .ApwjISqJuDYEGaCYaotN
  .ok4RCdndQu2JV3GMn4VD
  .PrRVWLDa8ject9CNjD4w {
  background-color: var(--theme-primary-color);
  border: none;
}

.e8siic_ICXmLcAr12pgU
  .ApwjISqJuDYEGaCYaotN
  .EeD_klL7wmLX7vgxX6VA
  .PrRVWLDa8ject9CNjD4w
  .ZAcvGhX0wQN9bz3z0hI1,
.e8siic_ICXmLcAr12pgU
  .ApwjISqJuDYEGaCYaotN
  .aFSrp88DK9sQdBbxx4Ie
  .PrRVWLDa8ject9CNjD4w
  .ZAcvGhX0wQN9bz3z0hI1,
.e8siic_ICXmLcAr12pgU
  .ApwjISqJuDYEGaCYaotN
  .ok4RCdndQu2JV3GMn4VD
  .PrRVWLDa8ject9CNjD4w
  .ZAcvGhX0wQN9bz3z0hI1 {
  color: var(--theme-primary-font-color);
}

.e8siic_ICXmLcAr12pgU
  .ApwjISqJuDYEGaCYaotN
  .EeD_klL7wmLX7vgxX6VA
  .SmkqAW7NJS55ddEjrHvA
  > span,
.e8siic_ICXmLcAr12pgU
  .ApwjISqJuDYEGaCYaotN
  .aFSrp88DK9sQdBbxx4Ie
  .SmkqAW7NJS55ddEjrHvA
  > span,
.e8siic_ICXmLcAr12pgU
  .ApwjISqJuDYEGaCYaotN
  .ok4RCdndQu2JV3GMn4VD
  .SmkqAW7NJS55ddEjrHvA
  > span {
  display: block;
}

.e8siic_ICXmLcAr12pgU
  .ApwjISqJuDYEGaCYaotN
  .EeD_klL7wmLX7vgxX6VA
  .SmkqAW7NJS55ddEjrHvA
  .BTTpo3u1c_LFoDPQlctV,
.e8siic_ICXmLcAr12pgU
  .ApwjISqJuDYEGaCYaotN
  .aFSrp88DK9sQdBbxx4Ie
  .SmkqAW7NJS55ddEjrHvA
  .BTTpo3u1c_LFoDPQlctV,
.e8siic_ICXmLcAr12pgU
  .ApwjISqJuDYEGaCYaotN
  .ok4RCdndQu2JV3GMn4VD
  .SmkqAW7NJS55ddEjrHvA
  .BTTpo3u1c_LFoDPQlctV {
  color: var(--theme-secondary-color-error);
  font-size: 0.12rem;
  vertical-align: text-bottom;
}

.e8siic_ICXmLcAr12pgU
  .ApwjISqJuDYEGaCYaotN
  .EeD_klL7wmLX7vgxX6VA
  .SmkqAW7NJS55ddEjrHvA
  .OTI74hwJsZWIrbxShtNQ,
.e8siic_ICXmLcAr12pgU
  .ApwjISqJuDYEGaCYaotN
  .aFSrp88DK9sQdBbxx4Ie
  .SmkqAW7NJS55ddEjrHvA
  .OTI74hwJsZWIrbxShtNQ,
.e8siic_ICXmLcAr12pgU
  .ApwjISqJuDYEGaCYaotN
  .ok4RCdndQu2JV3GMn4VD
  .SmkqAW7NJS55ddEjrHvA
  .OTI74hwJsZWIrbxShtNQ {
  color: var(--theme-text-color-darken);
  font-size: 0.16rem;
  margin-bottom: 0 !important;
}

.e8siic_ICXmLcAr12pgU
  .ApwjISqJuDYEGaCYaotN
  .EeD_klL7wmLX7vgxX6VA
  > div:last-of-type,
.e8siic_ICXmLcAr12pgU
  .ApwjISqJuDYEGaCYaotN
  .aFSrp88DK9sQdBbxx4Ie
  > div:last-of-type,
.e8siic_ICXmLcAr12pgU
  .ApwjISqJuDYEGaCYaotN
  .ok4RCdndQu2JV3GMn4VD
  > div:last-of-type {
  margin-bottom: 0;
}

.e8siic_ICXmLcAr12pgU
  .ApwjISqJuDYEGaCYaotN
  .ok4RCdndQu2JV3GMn4VD
  .ceiktj0nGFZYA3JZ65zu {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}

.e8siic_ICXmLcAr12pgU
  .ApwjISqJuDYEGaCYaotN
  .ok4RCdndQu2JV3GMn4VD
  .ceiktj0nGFZYA3JZ65zu
  li {
  -ms-flex-align: center;
  -ms-flex-pack: center;
  align-items: center;
  background-color: var(--theme-main-bg-color);
  border: thin solid var(--theme-color-line);
  border-radius: 0.1rem;
  color: var(--theme-text-color);
  cursor: pointer;
  display: -ms-flexbox;
  display: flex;
  font-size: 0.18rem;
  height: 0.6rem;
  justify-content: center;
  margin: 0 3.5% 0.2rem 0;
  position: relative;
  text-align: center;
  width: 22.375%;
  word-break: break-all;
}

.e8siic_ICXmLcAr12pgU
  .ApwjISqJuDYEGaCYaotN
  .ok4RCdndQu2JV3GMn4VD
  .ceiktj0nGFZYA3JZ65zu
  li:nth-child(4n) {
  margin-right: 0;
}

.e8siic_ICXmLcAr12pgU
  .ApwjISqJuDYEGaCYaotN
  .ok4RCdndQu2JV3GMn4VD
  .ceiktj0nGFZYA3JZ65zu
  li.AB1kiuea0ErQzBeHyxok {
  border-color: var(--theme-text-color-placeholder);
  color: var(--theme-text-color-placeholder);
  cursor: not-allowed;
}

.e8siic_ICXmLcAr12pgU
  .ApwjISqJuDYEGaCYaotN
  .ok4RCdndQu2JV3GMn4VD
  .ceiktj0nGFZYA3JZ65zu
  li[disabled='disabled'] {
  background-color: var(--theme-bg-color);
  color: var(--theme-text-color-placeholder);
  cursor: auto;
  pointer-events: none;
}

.e8siic_ICXmLcAr12pgU
  .ApwjISqJuDYEGaCYaotN
  .ok4RCdndQu2JV3GMn4VD
  .ceiktj0nGFZYA3JZ65zu
  li.tivA24cSEjfykc3h2PmN {
  border: thin solid var(--theme-filter-active-color);
  color: var(--theme-primary-color);
}

.e8siic_ICXmLcAr12pgU
  .ApwjISqJuDYEGaCYaotN
  .ok4RCdndQu2JV3GMn4VD
  .ceiktj0nGFZYA3JZ65zu
  li.tivA24cSEjfykc3h2PmN
  .subscript
  .bg {
  color: var(--theme-filter-active-color);
}

.e8siic_ICXmLcAr12pgU
  .ApwjISqJuDYEGaCYaotN
  .ok4RCdndQu2JV3GMn4VD
  .ceiktj0nGFZYA3JZ65zu
  .r1QnBDk2QnzYN6t7hweu {
  max-width: 100%;
}

.e8siic_ICXmLcAr12pgU
  .ApwjISqJuDYEGaCYaotN
  .ok4RCdndQu2JV3GMn4VD
  .ceiktj0nGFZYA3JZ65zu
  .r1QnBDk2QnzYN6t7hweu
  p:first-child {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.e8siic_ICXmLcAr12pgU
  .ApwjISqJuDYEGaCYaotN
  .ok4RCdndQu2JV3GMn4VD
  .eB3l_JiD0MaOl9Fyxzk7 {
  position: relative;
}

.e8siic_ICXmLcAr12pgU
  .ApwjISqJuDYEGaCYaotN
  .ok4RCdndQu2JV3GMn4VD
  .eB3l_JiD0MaOl9Fyxzk7
  .LRfaqCxGGdXMNmz8w0OP
  input:focus {
  font-weight: 700;
}

.e8siic_ICXmLcAr12pgU
  .ApwjISqJuDYEGaCYaotN
  .ok4RCdndQu2JV3GMn4VD
  .eB3l_JiD0MaOl9Fyxzk7
  .LRfaqCxGGdXMNmz8w0OP
  input::-webkit-input-placeholder {
  color: var(--theme-text-color-placeholder);
  font-size: 0.18rem;
  font-weight: 400;
}

.e8siic_ICXmLcAr12pgU
  .ApwjISqJuDYEGaCYaotN
  .ok4RCdndQu2JV3GMn4VD
  .eB3l_JiD0MaOl9Fyxzk7
  .LRfaqCxGGdXMNmz8w0OP
  input::-moz-placeholder {
  color: var(--theme-text-color-placeholder);
  font-size: 0.18rem;
  font-weight: 400;
}

.e8siic_ICXmLcAr12pgU
  .ApwjISqJuDYEGaCYaotN
  .ok4RCdndQu2JV3GMn4VD
  .eB3l_JiD0MaOl9Fyxzk7
  .LRfaqCxGGdXMNmz8w0OP
  input:-ms-input-placeholder {
  color: var(--theme-text-color-placeholder);
  font-size: 0.18rem;
  font-weight: 400;
}

.e8siic_ICXmLcAr12pgU
  .ApwjISqJuDYEGaCYaotN
  .ok4RCdndQu2JV3GMn4VD
  .eB3l_JiD0MaOl9Fyxzk7
  .LRfaqCxGGdXMNmz8w0OP
  .ant-input-prefix {
  left: 0.33rem;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}

.e8siic_ICXmLcAr12pgU
  .ApwjISqJuDYEGaCYaotN
  .ok4RCdndQu2JV3GMn4VD
  .eB3l_JiD0MaOl9Fyxzk7
  + .crWwWKooadMJU1HhTYJd {
  margin-top: 0.25rem;
}

.e8siic_ICXmLcAr12pgU
  .ApwjISqJuDYEGaCYaotN
  .ok4RCdndQu2JV3GMn4VD
  .JjaCSpEhZWJzvoHVrLYE {
  color: #ea4d3d;
  font-size: 0.16rem;
  margin-top: 0.06rem;
}

.e8siic_ICXmLcAr12pgU
  .ApwjISqJuDYEGaCYaotN
  .ok4RCdndQu2JV3GMn4VD
  .crWwWKooadMJU1HhTYJd
  > .lsrMXtUICwEcCf89wdKU {
  display: -ms-flexbox;
  display: flex;
  width: 100%;
}

.e8siic_ICXmLcAr12pgU
  .ApwjISqJuDYEGaCYaotN
  .ok4RCdndQu2JV3GMn4VD
  .crWwWKooadMJU1HhTYJd
  > .lsrMXtUICwEcCf89wdKU
  .N4qxOIUHNDu9VMvwcHt9 {
  color: var(--theme-text-color-lighten);
  font-size: 0.16rem;
  width: 1.72rem;
}

.e8siic_ICXmLcAr12pgU
  .ApwjISqJuDYEGaCYaotN
  .ok4RCdndQu2JV3GMn4VD
  .crWwWKooadMJU1HhTYJd
  > .lsrMXtUICwEcCf89wdKU
  .ceiktj0nGFZYA3JZ65zu
  li {
  margin-top: 0;
}

.e8siic_ICXmLcAr12pgU
  .ApwjISqJuDYEGaCYaotN
  .ok4RCdndQu2JV3GMn4VD
  .crWwWKooadMJU1HhTYJd
  > .lsrMXtUICwEcCf89wdKU
  .A7sXl2hEvzFAhns3t2SZ {
  -ms-flex: 1;
  flex: 1;
}

.e8siic_ICXmLcAr12pgU
  .ApwjISqJuDYEGaCYaotN
  .ok4RCdndQu2JV3GMn4VD
  .crWwWKooadMJU1HhTYJd
  > .lsrMXtUICwEcCf89wdKU
  .BRv5ls6FqYc41gklGaga {
  background-color: transparent;
  border: none;
  color: var(--theme-text-color-lighten);
  font-size: 0.16rem;
}

.e8siic_ICXmLcAr12pgU
  .ApwjISqJuDYEGaCYaotN
  .ok4RCdndQu2JV3GMn4VD
  .crWwWKooadMJU1HhTYJd
  > .lsrMXtUICwEcCf89wdKU
  .BRv5ls6FqYc41gklGaga:not(:lang(zh_CN)) {
  text-align: left;
  width: 100%;
}

.e8siic_ICXmLcAr12pgU
  .ApwjISqJuDYEGaCYaotN
  .ok4RCdndQu2JV3GMn4VD
  .crWwWKooadMJU1HhTYJd
  > .lsrMXtUICwEcCf89wdKU
  .M55pbFRB08XpcD4kUjwe {
  margin-right: 0.05rem;
}

.e8siic_ICXmLcAr12pgU
  .ApwjISqJuDYEGaCYaotN
  .ok4RCdndQu2JV3GMn4VD
  .crWwWKooadMJU1HhTYJd
  > .lsrMXtUICwEcCf89wdKU
  .qSIJw3s8QBxh5DGtD1UG {
  padding: 0 0.03rem;
}

.e8siic_ICXmLcAr12pgU
  .ApwjISqJuDYEGaCYaotN
  .ok4RCdndQu2JV3GMn4VD
  .crWwWKooadMJU1HhTYJd
  .QwKFOabTrB6JzfwQGLj1 {
  color: var(--theme-text-color);
  font-size: 0.18rem;
}

.e8siic_ICXmLcAr12pgU
  .ApwjISqJuDYEGaCYaotN
  .ok4RCdndQu2JV3GMn4VD
  .crWwWKooadMJU1HhTYJd
  .QwKFOabTrB6JzfwQGLj1
  > span {
  cursor: pointer;
}

.e8siic_ICXmLcAr12pgU
  .ApwjISqJuDYEGaCYaotN
  .ok4RCdndQu2JV3GMn4VD
  .crWwWKooadMJU1HhTYJd
  .QwKFOabTrB6JzfwQGLj1
  .ZAcvGhX0wQN9bz3z0hI1 {
  color: var(--theme-primary-color);
  font-size: 0.15rem;
  margin-right: 0.12rem;
}

.e8siic_ICXmLcAr12pgU
  .ApwjISqJuDYEGaCYaotN
  .ok4RCdndQu2JV3GMn4VD
  .crWwWKooadMJU1HhTYJd
  .HH8zfEFT54KOK3RHJzrw {
  color: var(--theme-text-color-lighten);
  font-size: 0.18rem;
  margin-bottom: 0;
  min-height: 0.26rem;
  position: relative;
}

.e8siic_ICXmLcAr12pgU
  .ApwjISqJuDYEGaCYaotN
  .ok4RCdndQu2JV3GMn4VD
  .crWwWKooadMJU1HhTYJd
  .HH8zfEFT54KOK3RHJzrw
  .fsw7N42rWkHNfzNqMy1j
  span {
  color: var(--theme-secondary-color-finance);
}

.e8siic_ICXmLcAr12pgU
  .ApwjISqJuDYEGaCYaotN
  .ok4RCdndQu2JV3GMn4VD
  .crWwWKooadMJU1HhTYJd
  .HH8zfEFT54KOK3RHJzrw
  .BAFtNuV7K2jYbG__6wsh {
  -ms-flex-align: center;
  align-items: center;
  color: var(--theme-primary-color);
  cursor: pointer;
  display: -ms-flexbox;
  display: flex;
  position: absolute;
  right: 0;
}

.e8siic_ICXmLcAr12pgU
  .ApwjISqJuDYEGaCYaotN
  .ok4RCdndQu2JV3GMn4VD
  .crWwWKooadMJU1HhTYJd
  .HH8zfEFT54KOK3RHJzrw
  .BAFtNuV7K2jYbG__6wsh
  .ZAcvGhX0wQN9bz3z0hI1 {
  font-size: 0.15rem;
}

.e8siic_ICXmLcAr12pgU .ApwjISqJuDYEGaCYaotN .ok4RCdndQu2JV3GMn4VD:last-child {
  border-bottom: none;
  padding-bottom: 0;
}

.e8siic_ICXmLcAr12pgU
  .ApwjISqJuDYEGaCYaotN
  .ok4RCdndQu2JV3GMn4VD[no-border='true'] {
  border-bottom: none;
}

.e8siic_ICXmLcAr12pgU .ApwjISqJuDYEGaCYaotN .CxzxowuSs763WJFvOlwg {
  border-bottom: thin dashed var(--theme-color-line);
}

.e8siic_ICXmLcAr12pgU
  .ApwjISqJuDYEGaCYaotN
  .EeD_klL7wmLX7vgxX6VA
  .SmkqAW7NJS55ddEjrHvA {
  margin-bottom: 0.1rem !important;
}

.e8siic_ICXmLcAr12pgU .ApwjISqJuDYEGaCYaotN .OTI74hwJsZWIrbxShtNQ {
  color: var(--theme-text-color-lighten);
  font-size: 0.18rem;
  margin-bottom: 0.3rem;
}

.e8siic_ICXmLcAr12pgU
  .ApwjISqJuDYEGaCYaotN
  .OTI74hwJsZWIrbxShtNQ
  .SmkqAW7NJS55ddEjrHvA {
  margin-bottom: 0.15rem;
}

.e8siic_ICXmLcAr12pgU .ApwjISqJuDYEGaCYaotN .HP9MdQkWYNfdRlW5Ev2e {
  -ms-flex-pack: justify;
  color: var(--theme-text-color-lighten);
  display: -ms-flexbox;
  display: flex;
  font-size: 0.18rem;
  justify-content: space-between;
  width: 100%;
}

.e8siic_ICXmLcAr12pgU .ApwjISqJuDYEGaCYaotN .HP9MdQkWYNfdRlW5Ev2e span > span {
  color: var(--theme-text-color-lighten);
  margin-left: 0.03rem;
}

.e8siic_ICXmLcAr12pgU .ApwjISqJuDYEGaCYaotN .HP9MdQkWYNfdRlW5Ev2e span label {
  color: var(--theme-text-color-darken);
}

.e8siic_ICXmLcAr12pgU
  .ApwjISqJuDYEGaCYaotN
  .HP9MdQkWYNfdRlW5Ev2e
  .J4297X5GEPbTiqQosS0Q {
  color: var(--theme-secondary-color-finance);
  font-weight: 700;
  text-align: right;
  white-space: pre-line;
}

.e8siic_ICXmLcAr12pgU
  .ApwjISqJuDYEGaCYaotN
  .HP9MdQkWYNfdRlW5Ev2e
  .N0grsN5UFY3p0sf6Q4qM {
  color: var(--theme-text-color-darken);
}

.e8siic_ICXmLcAr12pgU .ApwjISqJuDYEGaCYaotN article:first-of-type {
  margin-top: 0.1rem;
}

.e8siic_ICXmLcAr12pgU .ApwjISqJuDYEGaCYaotN article:last-of-type {
  margin-bottom: 0.1rem;
}

.e8siic_ICXmLcAr12pgU .ApwjISqJuDYEGaCYaotN article:last-child {
  margin-bottom: 0;
}

.e8siic_ICXmLcAr12pgU .JqPcJmLp1BV_0pDIq65q {
  color: var(--theme-text-color-darken);
  display: -ms-flexbox;
  display: flex;
  font-size: 0.18rem;
  margin-bottom: 0.2rem;
  word-break: break-all;
}

.e8siic_ICXmLcAr12pgU .JqPcJmLp1BV_0pDIq65q p {
  word-break: break-all;
}

.e8siic_ICXmLcAr12pgU .JqPcJmLp1BV_0pDIq65q .skay7CoS27qHRHU59J2Q {
  -ms-flex: 0 0 auto;
  flex: 0 0 auto;
  margin-right: 0.1rem;
}

.So_waOZgg7qEl0wURIQz {
  -ms-flex-align: center;
  align-items: center;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-direction: column;
  flex-direction: column;
  padding: 0.15rem;
}

.So_waOZgg7qEl0wURIQz .header-item-label {
  display: block;
  height: 0.5rem;
  overflow: hidden;
  text-align: center;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 0.9rem;
}
.So_waOZgg7qEl0wURIQz .imageWrap {
  color: var(--theme-primary-color);
  font-size: 0.36rem;
}
._recharge-header_1s451_30 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.2rem;
}
._recharge-header_1s451_30 ._title_1s451_36 {
  font-size: 0.24rem;
  font-weight: 700;
  color: var(--theme-text-color-darken);
}
.glbY5bkp9x7KTYOGrdBC {
  -ms-flex-align: center;
  -ms-flex-pack: center;
  align-items: center;
  display: -ms-flexbox;
  display: flex;
  justify-content: center;
  border-radius: 0.2rem;
  border: thin solid var(--theme-color-line);
}
.VOgj9FBCnkozjr2NA7rl .refresh-icon {
  color: var(--theme-mine-icon-color) !important;
  font-size: 0.28rem;
  width: 0.28rem;
  height: 0.28rem;
  margin-right: 0.05rem;
}
.vy918omw_N7rBkJ235XX .iw9FDOIygJyoQtUHSJAg > div {
  -ms-flex-align: center;
  align-items: center;
  display: -ms-flexbox;
  display: flex;
  font-size: 0.18rem;
}
.VOgj9FBCnkozjr2NA7rl .count-to {
  border-color: var(--theme-secondary-color-finance) !important;
  color: var(--theme-secondary-color-finance) !important;
  border-bottom: 0.02rem solid var(--theme-secondary-color-finance);
  display: inline-block;
  font-size: 0.23rem !important;
  margin: 0 0.06rem !important;
  max-width: 2.5rem;
}

._vmaNbC7tMMJ99x929N9 {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
}
._reward-box_k0yoz_88 {
  width: 100%;
  line-height: 0.32rem;
  background: var(--theme-main-bg-color);
  border-radius: 0 0 0.1rem 0.1rem;
  text-align: center;
  vertical-align: top;
}
._reward_k0yoz_88 {
  display: inline-block;
  width: 100%;
  font-size: 0.22rem;
  font-weight: 700;
  background: color-mix(in srgb,var(--theme-secondary-color-finance) 15%,transparent);
  color: var(--theme-secondary-color-finance);
  text-align: center;
  line-height: 0.36rem;
  border-radius: 0 0 0.1rem 0.1rem;
  vertical-align: top;
}
._give_1idld_30 {
  display: flex;
  justify-content: space-between;
  margin-bottom: 0.1rem;
  padding: 0.08rem 0.16rem;
  color: var(--theme-text-color-darken);
  font-size: 0.22rem;
  background: color-mix(
    in srgb,
    var(--theme-secondary-color-error) 6%,
    transparent
  );
  border: 0.01rem solid;
  border-color: color-mix(
    in srgb,
    var(--theme-secondary-color-error) 40%,
    transparent
  );
  border-top: none;
  border-radius: 0 0 0.1rem 0.1rem;
  box-shadow: 0 0.02rem 0.08rem rgba(0, 0, 0, 0.15);
}
._income_1idld_56 {
  color: var(--skin__lead);
  font-weight: 700;
  text-decoration: underline;
}
._receive-tips_1idld_48 {
  color: var(--theme-secondary-color-success);
}
._gift_1idld_51 {
  color: var(--theme-secondary-color-finance);
  text-decoration: underline;
  font-weight: 700;
}
._sdfisndifnsdf {
  border-radius: 0.1rem 0.1rem 0 0;
}
._tab-container_1aor4_37,
._normal-style-container_1aor4_38 {
  position: relative;
  margin-bottom: 0.2rem;
  border-radius: 0.2rem;
  border: 1px solid
    color-mix(in srgb, var(--theme-secondary-color-error) 50%, transparent);
  background: color-mix(
    in srgb,
    var(--theme-secondary-color-error) 6%,
    transparent
  );
}
._title_1aor4_30 {
  display: flex;
  align-items: center;
  margin: 0.1rem;
  justify-content: space-between;
}
._title-img_17u6z_30 {
  height: 0.4rem;
}
._title-img-right_17u6z_43 {
  margin-left: 0.2rem;
  background-color: transparent;
  border: 0;
  height: 0.4rem;
  padding: 0 0.08rem 0 0;
  display: inline-block;
  border-radius: 0 0.06rem 0.06rem 0;
  vertical-align: top;
  font-size: 0.24rem;
  font-weight: 600;
}
._title-img-right-cnt_17u6z_61 {
  display: flex;
  justify-content: center;
  align-items: center;
}
._title-img-right_17u6z_43 ._title-img-icon_17u6z_55 {
  width: 0.32rem;
  height: 0.32rem;
  margin: 0.04rem;
}
._title-img-right-text_17u6z_67 {
  display: inline-block;
  height: 0.32rem;
  line-height: 0.32rem;
  padding-left: 0.04rem;
  font-size: 0.24rem;
  font-weight: 600;
  color: var(--theme-text-color-darken);
}
._limited-time_43juf_30 {
  border: thin solid var(--theme-secondary-color-error);
  border-left: none;
}
._limited-time_43juf_30 > div {
  position: relative;
  left: -0.05rem;
  display: flex;
  align-items: center;
  font-size: 0.18rem;
}
._limited-time_43juf_30 ._time-img_43juf_41 {
  height: 0.27rem;
}
._limited-time_43juf_30 ._text_43juf_60 {
  background-color: var(--theme-secondary-color-error);
  color: #fff;
  line-height: 0.27rem;
  white-space: nowrap;
}
._limited-time_43juf_30 ._rectangle_43juf_44 {
  width: 0.15rem;
  height: 0.27rem;
  position: relative;
  left: -0.01rem;
  top: -0.01rem;
}
._limited-time_43juf_30 ._triangle_43juf_51 {
  position: absolute;
  top: 0;
  left: 0;
  width: 70%;
  height: 100%;
  background-color: var(--theme-secondary-color-error);
  clip-path: polygon(0 0, 100% 0, 0 100%);
}
._count-time_43juf_66 {
  width: 1rem;
  color: var(--theme-secondary-color-error);
}
._above_1aor4_55 {
    font-size: .2rem;
    height: .3rem;
    line-height: .3rem;
    margin-bottom: .1rem;
    text-align: center;
    color: var(--theme-text-color);
}

._option-item-cnt_1aor4_71 {
  position: relative;
}
._normal_1aor4_38 {
    margin: .1rem;
    border-radius: .1rem;
    font-size: .2rem;
    color: var(--theme-text-color);
    background-color: var(--theme-main-bg-color);
}

._left_1aor4_123 {
    display: flex;
    align-items: center;
    flex-shrink: 0;
    width: 60%;
}
._option-item-cnt_1aor4_71 {
    position: relative;
}

._border-left_1aor4_123 {
    position: absolute;
    left: 0;
    top: 0;
    width: .14rem;
    height: 100%;
    z-index: 1;
}

._border-left_1aor4_123::before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: var(--theme-secondary-color-finance);
    border-top-left-radius: .1rem;
    border-bottom-left-radius: .1rem;
    mask: linear-gradient(to left, transparent .06rem, white .06rem);
}
._img-je_1aor4_119 {
    width: .44rem;
    height: .44rem;
    margin: 0 .1rem 0 0;
}
 ._give_1aor4_170 {
    font-weight: 600;
    margin-right: .05rem;
    color: var(--theme-text-color-darken);
}
 ._currency_1aor4_183 {
    font-weight: 600;
    color: var(--theme-secondary-color-finance);
    margin: 0 .1rem 0 0;
}
 ._right_1aor4_162 {
    display: flex
;
    text-align: right;
    align-items: center;
}
._condition_1aor4_277 {
    position: relative;
}
._condition_1aor4_277 ._text_1aor4_280 {
    word-break: break-all;
    display: -webkit-box;
    overflow: hidden;
    text-overflow: ellipsis;
    vertical-align: middle;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    color: var(--theme-text-color-darken);
}
._amount_1aor4_300 {
    font-weight: 700;
    margin-left: .05rem;
    word-break: break-word;
}
._option-item-cnt_1aor4_71 {
    position: relative;
}
._option-item_1aor4_52 {
    padding: .16rem .2rem;
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    background-color: var(--theme-main-bg-color);
    align-items: center;
    font-size: .2rem;
    color: var(--skin__lead);
    padding: .16rem .2rem .16rem .18rem;
    height: .36rem;
}
._option-item_1aor4_52 ._icon-gou_1aor4_174 {
    color: var(--skin__accent_1);
    margin-left: .3rem;
    font-size: .3rem;
}

</style>
